"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatCurrencyAbsolute = exports.FormatCurrency = exports.Pluralize = exports.SortNumericIfPossible = exports.HumanizeTaskCategory = exports.TaskCategories = exports.TaskCategory = exports.HumanizeTaskStatus = exports.TaskStatuses = exports.TaskStatus = exports.AutomationValueDisplayAs = exports.AutomationValueRawValue = exports.AutomationValueDataType = exports.HumanizeAutomationRunStatus = exports.AutomationRunStatus = exports.AutomationConditionTypesPerDataType = exports.AutomationConditionTypes = exports.HumanizeAutomationConditionType = exports.AutomationConditionType = exports.AutomationCheckRequirement = exports.AutomationElementType = exports.AutomationDataType = exports.HumanizeGiftStatus = exports.GiftStatus = exports.HumanizeGiftingCampaignStatus = exports.GiftingCampaignStatus = exports.HumanizeDeliveryStatus = exports.DeliveryStatuses = exports.DeliveryStatus = exports.HumanizeExceptionReason = exports.ExceptionReasons = exports.ExceptionReason = exports.HumanizeExportDuties = exports.ExportDuties = exports.HumanizePackagingFormat = exports.PackagingFormats = exports.PackagingFormat = exports.HumanizeInventorySourceType = exports.InventorySourceTypes = exports.InventorySourceType = exports.HumanizeInventoryCondition = exports.InventoryConditions = exports.InventoryCondition = exports.NumberToChar = exports.InventoryLocationNameWithSite = exports.HumanizeInventoryCategory = exports.InventoryCategories = exports.InventoryCategory = exports.HumanizeInventoryLocationAccessibility = exports.InventoryLocationAccessibilities = exports.InventoryLocationAccessibility = exports.Inventory = exports.HumanizeShippingRegion = exports.ShippingRegions = exports.ShippingRegion = exports.InvoiceStatus = exports.HumanizeWROServiceLevel = exports.WROServiceLevels = exports.WROServiceLevel = exports.HumanizeWROPackaging = exports.WROPackagings = exports.WROPackaging = exports.HumanizeWROStatus = exports.WROStatuses = exports.WROStatus = exports.HumanizeRefundMethod = exports.RefundMethods = exports.RefundMethod = exports.HumanizeReturnResolution = exports.ReturnResolutions = exports.ReturnResolution = exports.HumanizeReturnReason = exports.ReturnReasons = exports.ReturnReason = exports.HumanizeReturnStatus = exports.ReturnStatuses = exports.ReturnStatus = exports.HumanizeClaimStatus = exports.ClaimStatuses = exports.ClaimStatus = exports.HumanizeIssueReporter = exports.IssueReporters = exports.IssueReporter = exports.HumanizeIssueReason = exports.IssueReasons = exports.IssueReason = exports.HumanizeIssueStatus = exports.IssueStatuses = exports.IssueStatus = exports.HumanizeProductStatus = exports.ProductStatuses = exports.ProductStatus = exports.PickSources = exports.HumanizePickSource = exports.PickSource = exports.AddonTissuePaperColors = exports.AuthAccessLevel = exports.AuthResourceType = exports.UserHasRole = exports.AddressToString = exports.HumanizeFontFamily = exports.FontFamilies = exports.FontFamily = exports.HumanizeClientStatus = exports.ClientStatuses = exports.ClientStatus = exports.HumanizeClientType = exports.ClientTypes = exports.ClientType = exports.HumanizeBillingMethod = exports.BillingMethods = exports.BillingMethod = exports.OrderChannels = exports.OrderChannel = exports.HumanizePackagingMaterial = exports.PackagingMaterials = exports.PackagingMaterial = exports.HumanizeProductType = exports.ProductTypes = exports.ProductType = exports.HumanizeShippingMethod = exports.ShippingMethod = exports.HumanizeCarrier = exports.ActiveCarriers = exports.Carriers = exports.Carrier = exports.HumanizeClientPackaging = exports.ClientPackagings = exports.ClientPackaging = exports.HumanizeAddonTrigger = exports.HumanizeAddonType = exports.AddonTriggers = exports.HumanizeAddonQuantity = exports.AddonQuantities = exports.AddonQuantity = exports.AddonTypes = exports.AddonTrigger = exports.AddonType = exports.HumanizeBlockedReasons = exports.BlockedReasons = exports.BlockedReason = exports.HumanizeOrderStatus = exports.Statuses = exports.OrderStatus = exports.BarcodeMatchesProduct = exports.APIClient = exports.Call = exports.Init = exports.DefaultClient = exports.NumberToCurrencyString = exports.BigIntToCurrencyString = exports.AuthScopesKey = exports.RefreshTokenKey = exports.AccessTokenKey = void 0;
var axios_1 = require("axios");
var base_64_1 = require("base-64");
// used for cookies etc
exports.AccessTokenKey = 'hutch.auth.access';
exports.RefreshTokenKey = 'hutch.auth.token';
exports.AuthScopesKey = 'hutch.auth.scopes';
var errMissingScopes = new Error('missing scopes');
var errMissingAccessToken = new Error('missing access token');
var errInvalidAccessToken = new Error('invalid access token');
var errExpiredAccessToken = new Error('expired access token');
var errMissingRefreshToken = new Error('missing refresh token');
function BigIntToCurrencyString(currency, value) {
    if (!value)
        return '';
    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency,
    }).format(Number(value) / 100);
}
exports.BigIntToCurrencyString = BigIntToCurrencyString;
function NumberToCurrencyString(currency, value) {
    if (!value)
        return '';
    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency,
    }).format(value);
}
exports.NumberToCurrencyString = NumberToCurrencyString;
function Init(opts) {
    exports.DefaultClient = new APIClient(opts);
}
exports.Init = Init;
function Call(path, params, opts) {
    if (params === void 0) { params = {}; }
    if (opts === void 0) { opts = {}; }
    if (!exports.DefaultClient)
        return Promise.reject('client not initialized');
    return exports.DefaultClient.Call(path, params, opts);
}
exports.Call = Call;
var APIClient = /** @class */ (function () {
    function APIClient(opts) {
        this.Options = opts;
        if (!this.Options.BaseURL)
            this.Options.BaseURL = 'https://api.tryhutch.co.uk/';
        setInterval(this.refreshAccessTokenIfRequired.bind(this), 60000);
    }
    APIClient.prototype.refreshAccessTokenIfRequired = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, fiveMinTime, expiresAt, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.UserFromAccessToken()];
                    case 1:
                        user = (_a.sent());
                        fiveMinTime = new Date();
                        fiveMinTime.setMinutes(fiveMinTime.getMinutes() + 5);
                        expiresAt = new Date(user.exp * 1000);
                        if (fiveMinTime >= expiresAt)
                            this.RefreshToken();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    APIClient.prototype.Logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.Options.RemoveAccessToken()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.Options.RemoveRefreshToken()];
                    case 2:
                        _a.sent();
                        this.Options.RedirectToLogin();
                        return [2 /*return*/];
                }
            });
        });
    };
    APIClient.prototype.ValidateAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var token, comps, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.Options.GetAccessToken()];
                                case 1:
                                    token = _a.sent();
                                    if (!token) {
                                        reject(errMissingAccessToken);
                                        return [2 /*return*/];
                                    }
                                    comps = token.split('.');
                                    if (comps.length !== 3) {
                                        reject(errInvalidAccessToken);
                                        return [2 /*return*/];
                                    }
                                    result = JSON.parse(base_64_1.decode(comps[1]));
                                    if (!result) {
                                        reject(errInvalidAccessToken);
                                        return [2 /*return*/];
                                    }
                                    if (Math.floor(Date.now() / 1000) > result.exp) {
                                        reject(errExpiredAccessToken);
                                        return [2 /*return*/];
                                    }
                                    resolve(true);
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    APIClient.prototype.UserFromAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var token, comps, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.Options.GetAccessToken()];
                                case 1:
                                    token = _a.sent();
                                    if (!token) {
                                        reject(errMissingAccessToken);
                                        return [2 /*return*/];
                                    }
                                    comps = token.split('.');
                                    result = JSON.parse(base_64_1.decode(comps[1]));
                                    if (!result) {
                                        reject(errInvalidAccessToken);
                                        return [2 /*return*/];
                                    }
                                    resolve(result);
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    APIClient.prototype.RefreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var scopes, refresh;
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.Options.GetScopes()];
                                case 1:
                                    scopes = _a.sent();
                                    if (!scopes) {
                                        reject(errMissingScopes);
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, this.Options.GetRefreshToken()];
                                case 2:
                                    refresh = _a.sent();
                                    if (!refresh) {
                                        reject(errMissingRefreshToken);
                                        return [2 /*return*/];
                                    }
                                    axios_1.default
                                        .post(this.Options.BaseURL + 'auth/Refresh', { refresh_token: refresh, scopes: scopes })
                                        .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, this.Options.SetAccessToken(res.data.access_token)];
                                                case 1:
                                                    _a.sent();
                                                    return [4 /*yield*/, this.Options.SetScopes(res.data.scopes)];
                                                case 2:
                                                    _a.sent();
                                                    resolve();
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); })
                                        .catch(function (err) {
                                        var _a, _b;
                                        var msg = (((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || err.message);
                                        if (msg.startsWith('rpc error:'))
                                            msg = msg.split('desc = ')[1] || msg;
                                        reject(msg);
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    APIClient.prototype.Call = function (path, params, opts) {
        var _this = this;
        if (params === void 0) { params = {}; }
        if (opts === void 0) { opts = {}; }
        if (this.Options.DefaultCallOptions)
            opts = __assign(__assign({}, this.Options.DefaultCallOptions), opts);
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var error_2, _a, error_3, token, serializedParams;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!opts.SkipAuth) return [3 /*break*/, 16];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 14]);
                        return [4 /*yield*/, this.ValidateAccessToken()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 14];
                    case 3:
                        error_2 = _b.sent();
                        _a = error_2;
                        switch (_a) {
                            case errMissingAccessToken: return [3 /*break*/, 4];
                            case errInvalidAccessToken: return [3 /*break*/, 4];
                            case errExpiredAccessToken: return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 11];
                    case 4: return [4 /*yield*/, this.Options.RemoveAccessToken()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 10]);
                        return [4 /*yield*/, this.RefreshToken()];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 10];
                    case 8:
                        error_3 = _b.sent();
                        return [4 /*yield*/, this.Options.RemoveRefreshToken()];
                    case 9:
                        _b.sent();
                        this.Options.RedirectToLogin();
                        reject("Error refreshing access token: " + error_3);
                        return [3 /*break*/, 10];
                    case 10: return [3 /*break*/, 13];
                    case 11: return [4 /*yield*/, this.Options.RemoveRefreshToken()];
                    case 12:
                        _b.sent();
                        this.Options.RedirectToLogin();
                        reject("Unexpected error validating access token: " + error_2);
                        return [2 /*return*/];
                    case 13: return [3 /*break*/, 14];
                    case 14: return [4 /*yield*/, this.Options.GetAccessToken()];
                    case 15:
                        token = _b.sent();
                        if (!opts.Headers)
                            opts.Headers = {};
                        opts.Headers.Authorization = 'Bearer ' + token;
                        _b.label = 16;
                    case 16:
                        serializedParams = JSON.parse(JSON.stringify(params, function (_, value) { return (typeof value === 'bigint' ? value.toString() : value); }));
                        axios_1.default
                            .post(this.Options.BaseURL + path, serializedParams, { headers: opts.Headers })
                            .then(function (res) {
                            resolve(res.data);
                        })
                            .catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                            var error_4, msg;
                            var _a, _b, _c;
                            return __generator(this, function (_d) {
                                switch (_d.label) {
                                    case 0:
                                        if (!(((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && !opts.RetryDisabled)) return [3 /*break*/, 7];
                                        _d.label = 1;
                                    case 1:
                                        _d.trys.push([1, 3, , 6]);
                                        return [4 /*yield*/, this.RefreshToken()];
                                    case 2:
                                        _d.sent();
                                        this.Call(path, params, __assign(__assign({}, opts), { RetryDisabled: true }))
                                            .then(resolve)
                                            .catch(reject);
                                        return [3 /*break*/, 6];
                                    case 3:
                                        error_4 = _d.sent();
                                        return [4 /*yield*/, this.Options.RemoveAccessToken()];
                                    case 4:
                                        _d.sent();
                                        return [4 /*yield*/, this.Options.RemoveRefreshToken()];
                                    case 5:
                                        _d.sent();
                                        this.Options.RedirectToLogin();
                                        reject('Unable to authenticate');
                                        return [3 /*break*/, 6];
                                    case 6: return [2 /*return*/];
                                    case 7:
                                        msg = (((_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || err.message);
                                        if (msg.startsWith('rpc error:'))
                                            msg = msg.split('desc = ')[1] || msg;
                                        reject(msg);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    return APIClient;
}());
exports.APIClient = APIClient;
exports.BarcodeMatchesProduct = function (barcode, prod) {
    var _a;
    barcode = barcode.toUpperCase().replace(/\s/g, '').trim();
    var barcodes = (_a = prod === null || prod === void 0 ? void 0 : prod.barcode) === null || _a === void 0 ? void 0 : _a.split(',').map(function (s) { return s.toUpperCase().replace(/\s/g, '').trim(); });
    return !!(barcodes === null || barcodes === void 0 ? void 0 : barcodes.find(function (b) { return b === barcode || b === '0' + barcode || '0' + b === barcode || '*' + b + '*' === barcode; }));
};
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Unknown"] = "Unknown";
    OrderStatus["Pending"] = "Pending";
    OrderStatus["Blocked"] = "Blocked";
    OrderStatus["Picking"] = "Picking";
    OrderStatus["Picked"] = "Picked";
    OrderStatus["Packed"] = "Packed";
    OrderStatus["QualityAssured"] = "QualityAssured";
    OrderStatus["Shipped"] = "Shipped";
    OrderStatus["Cancelled"] = "Cancelled";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
exports.Statuses = [
    OrderStatus.Pending,
    OrderStatus.Blocked,
    OrderStatus.Picking,
    OrderStatus.Picked,
    OrderStatus.Packed,
    OrderStatus.QualityAssured,
    OrderStatus.Shipped,
    OrderStatus.Cancelled,
];
exports.HumanizeOrderStatus = (_a = {},
    _a[OrderStatus.Unknown] = 'Unknown',
    _a[OrderStatus.Pending] = 'Processing',
    _a[OrderStatus.Blocked] = 'On Hold',
    _a[OrderStatus.Picking] = 'Picking',
    _a[OrderStatus.Picked] = 'Picked',
    _a[OrderStatus.Packed] = 'Packed',
    _a[OrderStatus.QualityAssured] = 'Quality Assured',
    _a[OrderStatus.Shipped] = 'Shipped',
    _a[OrderStatus.Cancelled] = 'Cancelled',
    _a);
var BlockedReason;
(function (BlockedReason) {
    BlockedReason["Unknown"] = "BlockedReasonUnknown";
    BlockedReason["Inventory"] = "Inventory";
    BlockedReason["FraudRisk"] = "FraudRisk";
    BlockedReason["InvalidAddress"] = "InvalidAddress";
    BlockedReason["ReviewRequired"] = "ReviewRequired";
    BlockedReason["CustomerRequest"] = "CustomerRequest";
    BlockedReason["MissingProductData"] = "MissingProductData";
    BlockedReason["MissingCustomsValue"] = "MissingCustomsValue";
    BlockedReason["InvalidShippingMethod"] = "InvalidShippingMethod";
    BlockedReason["AwaitingPayment"] = "AwaitingPayment";
})(BlockedReason = exports.BlockedReason || (exports.BlockedReason = {}));
exports.BlockedReasons = [
    BlockedReason.Inventory,
    BlockedReason.FraudRisk,
    BlockedReason.InvalidAddress,
    BlockedReason.ReviewRequired,
    BlockedReason.CustomerRequest,
    BlockedReason.MissingProductData,
    BlockedReason.MissingCustomsValue,
    BlockedReason.InvalidShippingMethod,
    BlockedReason.AwaitingPayment,
];
exports.HumanizeBlockedReasons = (_b = {},
    _b[BlockedReason.Unknown] = 'Unknown',
    _b[BlockedReason.Inventory] = 'Inventory unavailable',
    _b[BlockedReason.FraudRisk] = 'Fraud risk',
    _b[BlockedReason.InvalidAddress] = 'Invalid address',
    _b[BlockedReason.ReviewRequired] = 'Review required',
    _b[BlockedReason.CustomerRequest] = 'Customer Request',
    _b[BlockedReason.MissingProductData] = 'Missing product data',
    _b[BlockedReason.MissingCustomsValue] = 'Missing customs value',
    _b[BlockedReason.InvalidShippingMethod] = 'Invalid shipping method',
    _b[BlockedReason.AwaitingPayment] = 'Awaiting Payment',
    _b);
var AddonType;
(function (AddonType) {
    AddonType["Unknown"] = "Unknown";
    AddonType["TissuePaper"] = "TissuePaper";
    AddonType["PersonalizedNote"] = "PersonalizedNote";
    AddonType["HandwrittenNote"] = "HandwrittenNote";
    AddonType["Insert"] = "Insert";
    AddonType["PackingInstruction"] = "PackingInstruction";
    AddonType["Sticker"] = "Sticker";
    AddonType["Product"] = "Product";
})(AddonType = exports.AddonType || (exports.AddonType = {}));
var AddonTrigger;
(function (AddonTrigger) {
    AddonTrigger["Unknown"] = "TriggerTypeUnknown";
    AddonTrigger["Always"] = "Always";
    AddonTrigger["Set"] = "Set";
    AddonTrigger["Channel"] = "Channel";
    AddonTrigger["Note"] = "Note";
    AddonTrigger["SKU"] = "SKU";
    AddonTrigger["NotInSetSKU"] = "NotInSetSKU";
    AddonTrigger["FirstDayOfWeekInMonth"] = "FirstDayOfWeekInMonth";
    AddonTrigger["ExceptSKU"] = "ExceptSKU";
    AddonTrigger["SKUContains"] = "SKUContains";
    AddonTrigger["ChannelTag"] = "ChannelTag";
    AddonTrigger["NoChannelTag"] = "NoChannelTag";
})(AddonTrigger = exports.AddonTrigger || (exports.AddonTrigger = {}));
exports.AddonTypes = [
    AddonType.TissuePaper,
    AddonType.HandwrittenNote,
    AddonType.Insert,
    AddonType.PackingInstruction,
    AddonType.Sticker,
    AddonType.Product,
];
var AddonQuantity;
(function (AddonQuantity) {
    AddonQuantity["Unknown"] = "QuantityUnknown";
    AddonQuantity["One"] = "One";
    AddonQuantity["OnePerUnit"] = "OnePerUnit";
})(AddonQuantity = exports.AddonQuantity || (exports.AddonQuantity = {}));
exports.AddonQuantities = [AddonQuantity.One, AddonQuantity.OnePerUnit];
exports.HumanizeAddonQuantity = (_c = {},
    _c[AddonQuantity.Unknown] = 'Unknown',
    _c[AddonQuantity.One] = 'Always One',
    _c[AddonQuantity.OnePerUnit] = 'One per unit',
    _c);
exports.AddonTriggers = [
    AddonTrigger.Always,
    AddonTrigger.Channel,
    AddonTrigger.Set,
    AddonTrigger.Note,
    AddonTrigger.SKU,
    AddonTrigger.NotInSetSKU,
    AddonTrigger.ExceptSKU,
    AddonTrigger.SKUContains,
    AddonTrigger.ChannelTag,
    AddonTrigger.NoChannelTag,
];
exports.HumanizeAddonType = (_d = {},
    _d[AddonType.Unknown] = 'Unknown',
    _d[AddonType.TissuePaper] = 'Tissue Paper',
    _d[AddonType.HandwrittenNote] = 'Handwritten Note',
    _d[AddonType.PersonalizedNote] = 'Handwritten Note',
    _d[AddonType.PackingInstruction] = 'Packing Instructions',
    _d[AddonType.Insert] = 'Insert',
    _d[AddonType.Sticker] = 'Sticker',
    _d[AddonType.Product] = 'Product',
    _d);
exports.HumanizeAddonTrigger = (_e = {},
    _e[AddonTrigger.Unknown] = 'Unknown',
    _e[AddonTrigger.Always] = 'Every order',
    _e[AddonTrigger.Set] = 'Only for orders containing a particular set',
    _e[AddonTrigger.SKU] = 'Only for orders containing a particular item',
    _e[AddonTrigger.NotInSetSKU] = 'Only for orders containing a standalone item (the item was not part of a set)',
    _e[AddonTrigger.Channel] = 'Only for orders coming from a particular channel',
    _e[AddonTrigger.Note] = 'Only for orders with a note',
    _e[AddonTrigger.FirstDayOfWeekInMonth] = 'Only for orders created on the first day in a month (e.g. first Saturday)',
    _e[AddonTrigger.ExceptSKU] = 'Every order not containing a particular item',
    _e[AddonTrigger.SKUContains] = 'Every order which has a SKU containing',
    _e[AddonTrigger.ChannelTag] = 'Every order has a tag matching',
    _e[AddonTrigger.NoChannelTag] = 'Every order which does not have a tag matching',
    _e);
var ClientPackaging;
(function (ClientPackaging) {
    ClientPackaging["Unknown"] = "PackagingUnknown";
    ClientPackaging["BoxSmall"] = "BoxSmall";
    ClientPackaging["BoxMedium"] = "BoxMedium";
    ClientPackaging["BoxLarge"] = "BoxLarge";
    ClientPackaging["BagMedium"] = "BagMedium";
    ClientPackaging["BagLarge"] = "BagLarge";
    ClientPackaging["JiffyEnvelope"] = "JiffyEnvelope";
})(ClientPackaging = exports.ClientPackaging || (exports.ClientPackaging = {}));
exports.ClientPackagings = [
    ClientPackaging.BoxSmall,
    ClientPackaging.BoxMedium,
    ClientPackaging.BoxLarge,
    ClientPackaging.BagMedium,
    ClientPackaging.BagLarge,
    ClientPackaging.JiffyEnvelope,
];
exports.HumanizeClientPackaging = (_f = {},
    _f[ClientPackaging.Unknown] = 'Unknown',
    _f[ClientPackaging.BoxSmall] = 'Small Box',
    _f[ClientPackaging.BoxMedium] = 'Medium Box',
    _f[ClientPackaging.BoxLarge] = 'Large Box',
    _f[ClientPackaging.BagMedium] = 'Medium Bag',
    _f[ClientPackaging.BagLarge] = 'Large Bag',
    _f[ClientPackaging.JiffyEnvelope] = 'Jiffy Envelope',
    _f);
var Carrier;
(function (Carrier) {
    Carrier["Collection"] = "CarrierUnknown";
    Carrier["RoyalMail"] = "RoyalMail";
    Carrier["DPD"] = "DPD";
    Carrier["DHL"] = "DHL";
    Carrier["Transglobal"] = "Transglobal";
    Carrier["Hived"] = "Hived";
    Carrier["FedEx"] = "FedEx";
    Carrier["DHLEcommerce"] = "DHLEcommerce";
    Carrier["FedExConnect"] = "FedExConnect";
    Carrier["Packfleet"] = "Packfleet";
    Carrier["CSM"] = "CSM";
    Carrier["APC"] = "APC";
    Carrier["Samos"] = "Samos";
    Carrier["AnPost"] = "AnPost";
    Carrier["Evri"] = "Evri";
    Carrier["Whistl"] = "Whistl";
    Carrier["ProCarrier"] = "ProCarrier";
    Carrier["UPS"] = "UPS";
    Carrier["AGL"] = "AGL";
    Carrier["AddressOnly"] = "AddressOnly";
    Carrier["IntersoftAmazonShipping"] = "IntersoftAmazonShipping";
})(Carrier = exports.Carrier || (exports.Carrier = {}));
exports.Carriers = [
    Carrier.Collection,
    Carrier.RoyalMail,
    Carrier.DPD,
    Carrier.DHL,
    Carrier.Transglobal,
    Carrier.Hived,
    Carrier.FedEx,
    Carrier.FedExConnect,
    Carrier.DHLEcommerce,
    Carrier.Packfleet,
    Carrier.CSM,
    Carrier.APC,
    Carrier.Samos,
    Carrier.Samos,
    Carrier.AnPost,
    Carrier.Evri,
    Carrier.Whistl,
    Carrier.ProCarrier,
    Carrier.UPS,
    Carrier.AGL,
    Carrier.AddressOnly,
    Carrier.IntersoftAmazonShipping,
];
exports.ActiveCarriers = [
    Carrier.Transglobal,
    Carrier.DPD,
    Carrier.DHL,
    Carrier.Packfleet,
    Carrier.RoyalMail,
    Carrier.CSM,
    Carrier.APC,
    Carrier.Samos,
    Carrier.AnPost,
    Carrier.Evri,
    Carrier.Whistl,
    Carrier.ProCarrier,
    Carrier.UPS,
    Carrier.AGL,
    Carrier.DHLEcommerce,
    Carrier.AddressOnly,
    Carrier.IntersoftAmazonShipping,
];
exports.HumanizeCarrier = (_g = {},
    _g[Carrier.Collection] = 'Collection',
    _g[Carrier.RoyalMail] = 'Royal Mail',
    _g[Carrier.DPD] = 'DPD',
    _g[Carrier.DHL] = 'DHL',
    _g[Carrier.Transglobal] = 'Transglobal',
    _g[Carrier.Hived] = 'Hived',
    _g[Carrier.FedEx] = 'FedEx',
    _g[Carrier.FedExConnect] = 'FedEx Cross Border',
    _g[Carrier.Packfleet] = 'Packfleet',
    _g[Carrier.CSM] = 'CSM',
    _g[Carrier.APC] = 'APC',
    _g[Carrier.Samos] = 'Samos',
    _g[Carrier.AnPost] = 'AnPost',
    _g[Carrier.Evri] = 'Evri',
    _g[Carrier.Whistl] = 'Whistl',
    _g[Carrier.ProCarrier] = 'ProCarrier',
    _g[Carrier.UPS] = 'UPS',
    _g[Carrier.AGL] = 'AGL',
    _g[Carrier.DHLEcommerce] = 'DHL eCommerce',
    _g[Carrier.AddressOnly] = 'Robert Guy',
    _g[Carrier.IntersoftAmazonShipping] = 'Amazon Shipping (Intersoft)',
    _g);
var ShippingMethod;
(function (ShippingMethod) {
    ShippingMethod["Unknown"] = "ShippingMethodUnknown";
    ShippingMethod["Delivery"] = "Delivery";
    ShippingMethod["Collection"] = "Collection";
    ShippingMethod["UKFirstClass"] = "DeliveryUKFirstClass";
    ShippingMethod["UKFirstClassTracked"] = "DeliveryUKFirstClassTracked";
    ShippingMethod["UKFirstClassTrackedAge"] = "DeliveryUKFirstClassTrackedAge";
    ShippingMethod["UKFirstClassTrackedSigned"] = "DeliveryUKFirstClassTrackedSigned";
    ShippingMethod["UKSecondClass"] = "DeliveryUKSecondClass";
    ShippingMethod["UKSecondClassTracked"] = "DeliveryUKSecondClassTracked";
    ShippingMethod["UKSecondClassTrackedAge"] = "DeliveryUKSecondClassTrackedAge";
    ShippingMethod["UKSecondClassTrackedSigned"] = "DeliveryUKSecondClassTrackedSigned";
    ShippingMethod["UKSecondClassTrackedReturn"] = "DeliveryUKSecondClassTrackedReturn";
    ShippingMethod["UKSpecialDeliveryBy1pm"] = "DeliveryUKSpecialDeliveryBy1pm";
    ShippingMethod["UKSpecialDeliveryGuaranteed750"] = "DeliveryUKSpecialDeliveryGuaranteed750";
    ShippingMethod["UKSpecialDeliveryGuaranteed1000"] = "DeliveryUKSpecialDeliveryGuaranteed1000";
    ShippingMethod["UKSpecialDeliveryGuaranteed2500"] = "DeliveryUKSpecialDeliveryGuaranteed2500";
    ShippingMethod["InternationalTrackedHeavy"] = "DeliveryInternationalTrackedHeavy";
    ShippingMethod["InternationalTrackedHeavyExtraComp"] = "DeliveryInternationalTrackedHeavyExtraComp";
    ShippingMethod["InternationalTrackedHeavyPriority"] = "DeliveryInternationalTrackedHeavyPriority";
    ShippingMethod["InternationalTrackedHeavyPriorityExtraComp"] = "DeliveryInternationalTrackedHeavyPriorityExtraComp";
    ShippingMethod["InternationalBusinessMailZoneSortPriority"] = "DeliveryInternationalBusinessMailZoneSortPriority";
    ShippingMethod["InternationalTrackedSignedOnAccount"] = "DeliveryInternationalTrackedSignedOnAccount";
    ShippingMethod["InternationalStandardOnAccount"] = "DeliveryInternationalStandardOnAccount";
    ShippingMethod["UKNextDayTracked"] = "DeliveryUKNextDayTracked";
    ShippingMethod["UKNextDayBefore1030"] = "DeliveryUKNextDayBefore1030";
    ShippingMethod["UKNextDayBefore1200"] = "DeliveryUKNextDayBefore1200";
    ShippingMethod["UKNextDaySaturday"] = "DeliveryUKNextDaySaturday";
    ShippingMethod["UKNextDaySaturdayBefore1030"] = "DeliveryUKNextDaySaturdayBefore1030";
    ShippingMethod["UKNextDaySaturdayBefore1200"] = "DeliveryUKNextDaySaturdayBefore1200";
    ShippingMethod["DPDAirClassic"] = "DeliveryDPDAirClassic";
    ShippingMethod["DPDTwoDay"] = "DeliveryDPDTwoDay";
    ShippingMethod["DPDAirExpress"] = "DeliveryDPDAirExpress";
    ShippingMethod["DPDAirLite"] = "DeliveryDPDAirLite";
    ShippingMethod["Europe"] = "DeliveryEurope";
    ShippingMethod["EuropeTracked"] = "DeliveryEuropeTracked";
    ShippingMethod["EuropeSigned"] = "DeliveryEuropeSigned";
    ShippingMethod["InternationalTrackedPDDP"] = "DeliveryInternationalTrackedPDDP";
    ShippingMethod["InternationalTrackedSignedPDDP"] = "DeliveryInternationalTrackedSignedPDDP";
    ShippingMethod["InternationalUntrackedPDDP"] = "DeliveryInternationalUntrackedPDDP";
    ShippingMethod["USTracked"] = "DeliveryUSTracked";
    ShippingMethod["TransglobalInternationalEconomy"] = "DeliveryTransglobalInternationalEconomy";
    ShippingMethod["TransglobalFedExInternationalEconomy"] = "DeliveryTransglobalFedExInternationalEconomy";
    ShippingMethod["TransglobalUSPSPrint"] = "DeliveryTransglobalUSPSPrint";
    ShippingMethod["RestOfWorld"] = "DeliveryRestOfWorldUntracked";
    ShippingMethod["RestOfWorldTracked"] = "DeliveryRestOfWorld";
    ShippingMethod["RestOfWorldSigned"] = "DeliveryRestOfWorldSigned";
    ShippingMethod["InternationalExpress"] = "DeliveryInternationalExpress";
    ShippingMethod["DHLEconomySelect"] = "DeliveryDHLEconomySelect";
    ShippingMethod["UKEcoSameDay"] = "DeliveryUKEcoSameDay";
    ShippingMethod["UKEcoNextDay"] = "DeliveryUKEcoNextDay";
    ShippingMethod["UKEcoTwoDay"] = "DeliveryUKEcoTwoDay";
    ShippingMethod["FedEx"] = "DeliveryFedEx";
    ShippingMethod["FedExNextDay"] = "DeliveryFedExNextDay";
    ShippingMethod["FedExInternationalEconomy"] = "DeliveryFedExInternationalEconomy";
    ShippingMethod["FedExInternationalPriority"] = "DeliveryFedExInternationalPriority";
    ShippingMethod["FedExFirst"] = "DeliveryFedExFirst";
    ShippingMethod["FedExPriorityExpress"] = "DeliveryFedExPriorityExpress";
    ShippingMethod["FedExPriority"] = "DeliveryFedExPriority";
    ShippingMethod["FedExEconomySelect"] = "DeliveryFedExEconomySelect";
    ShippingMethod["FedExPriorityExpressFreight"] = "DeliveryFedExPriorityExpressFreight";
    ShippingMethod["FedExPriorityFreight"] = "DeliveryFedExPriorityFreight";
    ShippingMethod["PackfleetNextDay"] = "DeliveryPackfleetNextDay";
    ShippingMethod["CSMEcom"] = "DeliveryCSMEcom";
    ShippingMethod["CSMEcomPlus"] = "DeliveryCSMEcomPlus";
    ShippingMethod["CSMEcomExpress"] = "DeliveryCSMEcomExpress";
    ShippingMethod["CSMDHLPaket"] = "DeliveryCSMDHLPaket";
    ShippingMethod["CSM900"] = "DeliveryCSM900";
    ShippingMethod["CSM1030"] = "DeliveryCSM1030";
    ShippingMethod["CSM1200"] = "DeliveryCSM1200";
    ShippingMethod["CSM2400"] = "DeliveryCSM2400";
    ShippingMethod["CSMExpress"] = "DeliveryCSMExpress";
    ShippingMethod["CSMEconomy"] = "DeliveryCSMEconomy";
    ShippingMethod["CSMSaturday"] = "DeliveryCSMSaturday";
    ShippingMethod["CSMSaturday1200"] = "DeliveryCSMSaturday1200";
    ShippingMethod["CSMSaturday1030"] = "DeliveryCSMSaturday1030";
    ShippingMethod["CSMSunday"] = "DeliveryCSMSunday";
    ShippingMethod["CSMSunday1200"] = "DeliveryCSMSunday1200";
    ShippingMethod["APCNextDayBy9"] = "DeliveryAPCNextDayBy9";
    ShippingMethod["APCNextDayBy10"] = "DeliveryAPCNextDayBy10";
    ShippingMethod["APCNextDayBy12"] = "DeliveryAPCNextDayBy12";
    ShippingMethod["APCNextDayBy16"] = "DeliveryAPCNextDayBy16";
    ShippingMethod["APCTwoToFiveDay"] = "DeliveryAPCTwoToFiveDay";
    ShippingMethod["APCSaturdayBy9"] = "DeliveryAPCSaturdayBy9";
    ShippingMethod["APCSaturdayBy10"] = "DeliveryAPCSaturdayBy10";
    ShippingMethod["APCSaturdayBy12"] = "DeliveryAPCSaturdayBy12";
    ShippingMethod["APCLiquidBy10"] = "DeliveryAPCLiquidBy10";
    ShippingMethod["APCLiquidBy12"] = "DeliveryAPCLiquidBy12";
    ShippingMethod["APCLiquidBy16"] = "DeliveryAPCLiquidBy16";
    ShippingMethod["APCCourierPackBy10"] = "DeliveryAPCCourierPackBy10";
    ShippingMethod["APCCourierPackBy12"] = "DeliveryAPCCourierPackBy12";
    ShippingMethod["APCCourierPackBy16"] = "DeliveryAPCCourierPackBy16";
    ShippingMethod["APCNonConveyableBy9"] = "DeliveryAPCNonConveyableBy9";
    ShippingMethod["APCNonConveyableBy10"] = "DeliveryAPCNonConveyableBy10";
    ShippingMethod["APCNonConveyableBy12"] = "DeliveryAPCNonConveyableBy12";
    ShippingMethod["APCNonConveyableBy16"] = "DeliveryAPCNonConveyableBy16";
    ShippingMethod["Samos"] = "DeliverySamos";
    ShippingMethod["MaerskParcelPremium"] = "DeliveryMaerskParcelPremium";
    ShippingMethod["MaerskParcelPremiumFML"] = "DeliveryMaerskParcelPremiumFML";
    ShippingMethod["MaerskParcelPlus"] = "DeliveryMaerskParcelPlus";
    ShippingMethod["MaerskParcelLiteLarge"] = "DeliveryMaerskParcelLiteLarge";
    ShippingMethod["MaerskParcelExpressPlus"] = "DeliveryMaerskExpressPlus";
    ShippingMethod["EvriStandard"] = "DeliveryEvriStandard";
    ShippingMethod["EvriNextDay"] = "DeliveryEvriNextDay";
    ShippingMethod["FedexConnectTrackedWorldwide"] = "DeliveryFedexConnectTrackedWorldwide";
    ShippingMethod["AnPostExpress"] = "DeliveryAnPostExpress";
    ShippingMethod["AnPostExpressWithSignature"] = "DeliveryAnPostExpressWithSignature";
    ShippingMethod["AnPostPriorityParcel"] = "DeliveryAnPostPriorityParcel";
    ShippingMethod["AnPostEMSParcel"] = "DeliveryAnPostEMSParcel";
    ShippingMethod["AnPostStandard"] = "DeliveryAnPostStandard";
    ShippingMethod["WhistlAmazonPremiumLargeLetter"] = "DeliveryWhistlAmazonPremiumLargeLetter";
    ShippingMethod["WhistlAmazonPremiumLargeParcel"] = "DeliveryWhistlAmazonPremiumLargeParcel";
    ShippingMethod["WhistlAmazonPremiumMediumParcel"] = "DeliveryWhistlAmazonPremiumMediumParcel";
    ShippingMethod["WhistlAmazonPremiumSmallParcel"] = "DeliveryWhistlAmazonPremiumSmallParcel";
    ShippingMethod["WhistlAmazonPremiumStandardParcel"] = "DeliveryWhistlAmazonPremiumStandardParcel";
    ShippingMethod["WhistlAmazonPremiumXLargeParcel"] = "DeliveryWhistlAmazonPremiumXLargeParcel";
    ShippingMethod["WhistlAmazonStandardLargeLetter"] = "DeliveryWhistlAmazonStandardLargeLetter";
    ShippingMethod["WhistlAmazonStandardLargeParcel"] = "DeliveryWhistlAmazonStandardLargeParcel";
    ShippingMethod["WhistlAmazonStandardMediumParcel"] = "DeliveryWhistlAmazonStandardMediumParcel";
    ShippingMethod["WhistlAmazonStandardSmallParcel"] = "DeliveryWhistlAmazonStandardSmallParcel";
    ShippingMethod["WhistlAmazonStandardStandardParcel"] = "DeliveryWhistlAmazonStandardStandardParcel";
    ShippingMethod["WhistlAmazonStandardXLargeParcel"] = "DeliveryWhistlAmazonStandardXLargeParcel";
    ShippingMethod["WhistlDPDExpressPak"] = "DeliveryWhistlDPDExpressPak";
    ShippingMethod["WhistlDPDExpressPak1030"] = "DeliveryWhistlDPDExpressPak1030";
    ShippingMethod["WhistlDPDExpressPak1200"] = "DeliveryWhistlDPDExpressPak1200";
    ShippingMethod["WhistlDPDExpressPakNextDay"] = "DeliveryWhistlDPDExpressPakNextDay";
    ShippingMethod["WhistlDPDExpressPakSat1030"] = "DeliveryWhistlDPDExpressPakSat1030";
    ShippingMethod["WhistlDPDExpressPakSat1200"] = "DeliveryWhistlDPDExpressPakSat1200";
    ShippingMethod["WhistlDPDExpressPakSaturday"] = "DeliveryWhistlDPDExpressPakSaturday";
    ShippingMethod["WhistlDPDExpressPakSun1030"] = "DeliveryWhistlDPDExpressPakSun1030";
    ShippingMethod["WhistlDPDExpressPakSun1200"] = "DeliveryWhistlDPDExpressPakSun1200";
    ShippingMethod["WhistlDPDExpressPakSunday"] = "DeliveryWhistlDPDExpressPakSunday";
    ShippingMethod["WhistlDPDParcel"] = "DeliveryWhistlDPDParcel";
    ShippingMethod["WhistlDPDParcel1030"] = "DeliveryWhistlDPDParcel1030";
    ShippingMethod["WhistlDPDParcel1200"] = "DeliveryWhistlDPDParcel1200";
    ShippingMethod["WhistlDPDParcelNextDay"] = "DeliveryWhistlDPDParcelNextDay";
    ShippingMethod["WhistlDPDParcelSat1030"] = "DeliveryWhistlDPDParcelSat1030";
    ShippingMethod["WhistlDPDParcelSat1200"] = "DeliveryWhistlDPDParcelSat1200";
    ShippingMethod["WhistlDPDParcelSaturday"] = "DeliveryWhistlDPDParcelSaturday";
    ShippingMethod["WhistlDPDParcelSun1200"] = "DeliveryWhistlDPDParcelSun1200";
    ShippingMethod["WhistlDPDParcelSunday"] = "DeliveryWhistlDPDParcelSunday";
    ShippingMethod["WhistlDPDParcelTwoDay"] = "DeliveryWhistlDPDParcelTwoDay";
    ShippingMethod["WhistlEvriLightLargeNPOD"] = "DeliveryWhistlEvriLightLargeNPOD";
    ShippingMethod["WhistlEvriLightLargePOD"] = "DeliveryWhistlEvriLightLargePOD";
    ShippingMethod["WhistlEvriPacketNextDayNPOD"] = "DeliveryWhistlEvriPacketNextDayNPOD";
    ShippingMethod["WhistlEvriPacketNextDayPOD"] = "DeliveryWhistlEvriPacketNextDayPOD";
    ShippingMethod["WhistlEvriPacketNPOD"] = "DeliveryWhistlEvriPacketNPOD";
    ShippingMethod["WhistlEvriPacketPOD"] = "DeliveryWhistlEvriPacketPOD";
    ShippingMethod["WhistlEvriParcelNextDayNPOD"] = "DeliveryWhistlEvriParcelNextDayNPOD";
    ShippingMethod["WhistlEvriParcelNextDayPOD"] = "DeliveryWhistlEvriParcelNextDayPOD";
    ShippingMethod["WhistlEvriParcelNPOD"] = "DeliveryWhistlEvriParcelNPOD";
    ShippingMethod["WhistlEvriParcelPOD"] = "DeliveryWhistlEvriParcelPOD";
    ShippingMethod["WhistlExelotExpediteLightFML"] = "DeliveryWhistlExelotExpediteLightFML";
    ShippingMethod["WhistlExelotExpediteLightBPMFML"] = "DeliveryWhistlExelotExpediteLightBPMFML";
    ShippingMethod["WhistlExelotExpediteMediaFML"] = "DeliveryWhistlExelotExpediteMediaFML";
    ShippingMethod["WhistlRoyalMailTracked24HVNONPOD"] = "DeliveryWhistlRoyalMailTracked24HVNONPOD";
    ShippingMethod["WhistlRoyalMailTracked24HVPOD"] = "DeliveryWhistlRoyalMailTracked24HVPOD";
    ShippingMethod["WhistlRoyalMailTracked24LBTHVNONPOD"] = "DeliveryWhistlRoyalMailTracked24LBTHVNONPOD";
    ShippingMethod["WhistlRoyalMailTracked24LBTHVPOD"] = "DeliveryWhistlRoyalMailTracked24LBTHVPOD";
    ShippingMethod["WhistlRoyalMailTracked24Returns"] = "DeliveryWhistlRoyalMailTracked24Returns";
    ShippingMethod["WhistlRoyalMailTracked48HVNONPOD"] = "DeliveryWhistlRoyalMailTracked48HVNONPOD";
    ShippingMethod["WhistlRoyalMailTracked48LBTHVNONPOD"] = "DeliveryWhistlRoyalMailTracked48LBTHVNONPOD";
    ShippingMethod["WhistlRoyalMailTracked48LBTHVPOD"] = "DeliveryWhistlRoyalMailTracked48LBTHVPOD";
    ShippingMethod["WhistlRoyalMailTracked48Returns"] = "DeliveryWhistlRoyalMailTracked48Returns";
    ShippingMethod["WhistlRoyalMailTracked48HVPOD"] = "DeliveryWhistlRoyalMailTracked48HVPOD";
    ShippingMethod["WhistlUPSStandardDomestic"] = "DeliveryWhistlUPSStandardDomestic";
    ShippingMethod["WhistlInSightInSightLargeLetter"] = "DeliveryWhistlInSightInSightLargeLetter";
    ShippingMethod["WhistlInSightInSightPacket"] = "DeliveryWhistlInSightInSightPacket";
    ShippingMethod["WhistlInSightInternationalInSightInternationalBoxable"] = "DeliveryWhistlInSightInternationalInSightInternationalBoxable";
    ShippingMethod["WhistlInSightInternationalInSightInternationalLargeLetter"] = "DeliveryWhistlInSightInternationalInSightInternationalLargeLetter";
    ShippingMethod["WhistlInSightInternationalInSightInternationalPacket"] = "DeliveryWhistlInSightInternationalInSightInternationalPacket";
    ShippingMethod["WhistlPremiumDDPPremiumParcelDDP"] = "DeliveryWhistlPremiumDDPPremiumParcelDDP";
    ShippingMethod["WhistlPremiumDDUPremiumParcelDDU"] = "DeliveryWhistlPremiumDDUPremiumParcelDDU";
    ShippingMethod["WhistlStandardDDUStandardBPMDDU"] = "DeliveryWhistlStandardDDUStandardBPMDDU";
    ShippingMethod["WhistlStandardDDUStandardParcelDDU"] = "DeliveryWhistlStandardDDUStandardParcelDDU";
    ShippingMethod["WhistlStandardDDUStandardParcelDDUIreland"] = "DeliveryWhistlStandardDDUStandardParcelDDUIreland";
    ShippingMethod["WhistlStandardDDUStandardSmallParcelDDU"] = "DeliveryWhistlStandardDDUStandardSmallParcelDDU";
    ShippingMethod["WhistlStandardIOSSStandardParcelIOSS"] = "DeliveryWhistlStandardIOSSStandardParcelIOSS";
    ShippingMethod["WhistlStandardIOSSStandardParcelIOSSIreland"] = "DeliveryWhistlStandardIOSSStandardParcelIOSSIreland";
    ShippingMethod["WhistlStandardRoadDDPStandardRoadParcelDDP"] = "DeliveryWhistlStandardRoadDDPStandardRoadParcelDDP";
    ShippingMethod["WhistlStandardRoadDDUStandardRoadParcelDDU"] = "DeliveryWhistlStandardRoadDDUStandardRoadParcelDDU";
    ShippingMethod["WhistlYodelXPECT24NPOD"] = "DeliveryWhistlYodelXPECT24NPOD";
    ShippingMethod["WhistlYodelXPECT24POD"] = "DeliveryWhistlYodelXPECT24POD";
    ShippingMethod["WhistlYodelXPECT48XLNPOD"] = "DeliveryWhistlYodelXPECT48XLNPOD";
    ShippingMethod["WhistlYodelXPECT48XLPOD"] = "DeliveryWhistlYodelXPECT48XLPOD";
    ShippingMethod["WhistlYodelXPRESS24NPOD"] = "DeliveryWhistlYodelXPRESS24NPOD";
    ShippingMethod["WhistlYodelXPRESS24POD"] = "DeliveryWhistlYodelXPRESS24POD";
    ShippingMethod["WhistlYodelXPRESS48NPOD"] = "DeliveryWhistlYodelXPRESS48NPOD";
    ShippingMethod["WhistlYodelXPRESS48POD"] = "DeliveryWhistlYodelXPRESS48POD";
    ShippingMethod["WhistlYodelCISTANDARDNPOD"] = "DeliveryWhistlYodelCISTANDARDNPOD";
    ShippingMethod["WhistlYodelCISTANDARDPOD"] = "DeliveryWhistlYodelCISTANDARDPOD";
    ShippingMethod["WhistlYodelXPECTMEDIUM24NONPOD"] = "DeliveryWhistlYodelXPECTMEDIUM24NONPOD";
    ShippingMethod["WhistlYodelXPECTMEDIUM24POD"] = "DeliveryWhistlYodelXPECTMEDIUM24POD";
    ShippingMethod["WhistlYodelXPECTMEDIUM48NONPOD"] = "DeliveryWhistlYodelXPECTMEDIUM48NONPOD";
    ShippingMethod["WhistlYodelXPECTMEDIUM48POD"] = "DeliveryWhistlYodelXPECTMEDIUM48POD";
    ShippingMethod["WhistlYodelXPECTMINI24NONPOD"] = "DeliveryWhistlYodelXPECTMINI24NONPOD";
    ShippingMethod["WhistlYodelXPECTMINI24POD"] = "DeliveryWhistlYodelXPECTMINI24POD";
    ShippingMethod["WhistlYodelXPECTMINI48NONPOD"] = "DeliveryWhistlYodelXPECTMINI48NONPOD";
    ShippingMethod["WhistlYodelXPECT48NPOD"] = "DeliveryWhistlYodelXPECT48NPOD";
    ShippingMethod["WhistlYodelXPECT48POD"] = "DeliveryWhistlYodelXPECT48POD";
    ShippingMethod["WhistlYodelXPECTSATURDAYNPOD"] = "DeliveryWhistlYodelXPECTSATURDAYNPOD";
    ShippingMethod["WhistlYodelXPECTSATURDAYPOD"] = "DeliveryWhistlYodelXPECTSATURDAYPOD";
    ShippingMethod["WhistlYodelXPRESSMINI48NONPOD"] = "DeliveryWhistlYodelXPRESSMINI48NONPOD";
    ShippingMethod["WhistlYodelXPRESSMINI481KGNONPOD"] = "DeliveryWhistlYodelXPRESSMINI481KGNONPOD";
    ShippingMethod["WhistlLibertyExpressParcelSelect"] = "DeliveryWhistlLibertyExpressParcelSelect";
    ShippingMethod["WhistlLibertyExpressUSPSGroundAdvantage"] = "DeliveryWhistlLibertyExpressUSPSGroundAdvantage";
    ShippingMethod["WhistlAPGEParcelGSTEUnpaid"] = "DeliveryWhistlAPGEParcelGSTEUnpaid";
    ShippingMethod["WhistlAPGEParcelGSTEPaid"] = "DeliveryWhistlAPGEParcelGSTEPaid";
    ShippingMethod["ProCarrierParcelExpress"] = "DeliveryProCarrierParcelExpress";
    ShippingMethod["ProCarrierParcelPlus"] = "DeliveryProCarrierParcelPlus";
    ShippingMethod["ProCarrierPacket"] = "DeliveryProCarrierPacket";
    ShippingMethod["ProCarrierParcelPost"] = "DeliveryProCarrierParcelPost";
    ShippingMethod["ProCarrierParcelUK"] = "DeliveryProCarrierParcelUK";
    ShippingMethod["ProCarrierNextDay"] = "DeliveryProCarrierNextDay";
    ShippingMethod["ProCarrierNextDayUK"] = "DeliveryProCarrierNextDayUK";
    ShippingMethod["ProCarrierNextDayUK24"] = "DeliveryProCarrierNextDayUK24";
    ShippingMethod["ProCarrierNextDayUK48"] = "DeliveryProCarrierNextDayUK48";
    ShippingMethod["ProCarrierUKSaturday"] = "DeliveryProCarrierUKSaturday";
    ShippingMethod["ProCarrierUKSunday"] = "DeliveryProCarrierUKSunday";
    ShippingMethod["ProCarrierUKBagIt"] = "DeliveryProCarrierUKBagIt";
    ShippingMethod["ProCarrierRoyalMailTracked24NoSignature"] = "DeliveryProCarrierRoyalMailTracked24NoSignature";
    ShippingMethod["ProCarrierRoyalMailTracked24Signature"] = "DeliveryProCarrierRoyalMailTracked24Signature";
    ShippingMethod["ProCarrierRoyalMailTracked48NoSignature"] = "DeliveryProCarrierRoyalMailTracked48NoSignature";
    ShippingMethod["ProCarrierRoyalMailTracked48Signature"] = "DeliveryProCarrierRoyalMailTracked48Signature";
    ShippingMethod["ProCarrierRoyalMailTrackedLetterboxable24NonSignature"] = "DeliveryProCarrierRoyalMailTrackedLetterboxable24NonSignature";
    ShippingMethod["ProCarrierRoyalMailTrackedLetterboxable24Signature"] = "DeliveryProCarrierRoyalMailTrackedLetterboxable24Signature";
    ShippingMethod["ProCarrierRoyalMailTrackedLetterboxable48NonSignature"] = "DeliveryProCarrierRoyalMailTrackedLetterboxable48NonSignature";
    ShippingMethod["ProCarrierRoyalMailTrackedLetterboxable48Signature"] = "DeliveryProCarrierRoyalMailTrackedLetterboxable48Signature";
    ShippingMethod["ProCarrierYodelXpect24XXLPOD"] = "DeliveryProCarrierYodelxpect24XXLPOD";
    ShippingMethod["ProCarrierYodelXpect24XXLNonPOD"] = "DeliveryProCarrierYodelxpect24XXLNonPOD";
    ShippingMethod["ProCarrierYodelXpect48XXLPOD"] = "DeliveryProCarrierYodelXpect48XXLPOD";
    ShippingMethod["ProCarrierYodelXpect48XXLNonPOD"] = "DeliveryProCarrierYodelXpect48XXLNonPOD";
    ShippingMethod["ProCarrierYodelWorldPacket"] = "DeliveryProCarrierYodelworldPacket";
    ShippingMethod["ProCarrierYodelWorldParcel"] = "DeliveryProCarrierYodelWorldParcel";
    ShippingMethod["ProCarrierCI48HRPOD"] = "DeliveryProCarrierCI48HRPOD";
    ShippingMethod["ProCarrierCI48HRNonPOD"] = "DeliveryProCarrierCI48HRNonPOD";
    ShippingMethod["ProCarrierXpect24MSPOD"] = "DeliveryProCarrierXpect24MSPOD";
    ShippingMethod["ProCarrierXpect24MSNonPOD"] = "DeliveryProCarrierXpect24MSNonPOD";
    ShippingMethod["ProCarrierXpect24MiniNonPOD"] = "DeliveryProCarrierXpect24MiniNonPOD";
    ShippingMethod["ProCarrierXpect24MediumPOD"] = "DeliveryProCarrierXpect24MediumPOD";
    ShippingMethod["ProCarrierXpect24MediumNonPOD"] = "DeliveryProCarrierXpect24MediumNonPOD";
    ShippingMethod["ProCarrierXpect48MiniNonPOD"] = "DeliveryProCarrierXpect48MiniNonPOD";
    ShippingMethod["ProCarrierXpect48MSPOD"] = "DeliveryProCarrierXpect48MSPOD";
    ShippingMethod["ProCarrierXpect48MSNonPOD"] = "DeliveryProCarrierXpect48MSNonPOD";
    ShippingMethod["ProCarrierXpect48MediumPOD"] = "DeliveryProCarrierXpect48MediumPOD";
    ShippingMethod["ProCarrierXpect48MediumNonPOD"] = "DeliveryProCarrierXpect48MediumNonPOD";
    ShippingMethod["ProCarrierXpect48XLPOD"] = "DeliveryProCarrierXpect48XLPOD";
    ShippingMethod["ProCarrierXpect48XLNonPOD"] = "DeliveryProCarrierXpect48XLNonPOD";
    ShippingMethod["DHLeCommerceConnectRoad"] = "DeliveryDHLeCommerceConnectRoad";
    ShippingMethod["DHLeCommerceConnectAir"] = "DeliveryDHLeCommerceConnectAir";
    ShippingMethod["DHLeCommerceParcelInternationalRoadEconomy"] = "DeliveryDHLeCommerceParcelInternationalRoadEconomy";
    ShippingMethod["DHLeCommerceParcelBagitLNeighbour"] = "DeliveryDHLeCommerceParcelBagitLNeighbour";
    ShippingMethod["DHLeCommerceParcelBagitXLNeighbour"] = "DeliveryDHLeCommerceParcelBagitXLNeighbour";
    ShippingMethod["DHLeCommerceParcelBagitSLeaveSafe"] = "DeliveryDHLeCommerceParcelBagitSLeaveSafe";
    ShippingMethod["DHLeCommerceParcelBagitMLeaveSafe"] = "DeliveryDHLeCommerceParcelBagitMLeaveSafe";
    ShippingMethod["DHLeCommerceParcelBagitLLeaveSafe"] = "DeliveryDHLeCommerceParcelBagitLLeaveSafe";
    ShippingMethod["DHLeCommerceParcelLeaveSafe"] = "DeliveryDHLeCommerceParcelLeaveSafe";
    ShippingMethod["DHLeCommerceParcelBagitS"] = "DeliveryDHLeCommerceParcelBagitS";
    ShippingMethod["DHLeCommerceParcelBagitM"] = "DeliveryDHLeCommerceParcelBagitM";
    ShippingMethod["DHLeCommerceParcelBagitL"] = "DeliveryDHLeCommerceParcelBagitL";
    ShippingMethod["DHLeCommerceParcelBagitXL"] = "DeliveryDHLeCommerceParcelBagitXL";
    ShippingMethod["DHLeCommerceParcelBagitSNeighbour"] = "DeliveryDHLeCommerceParcelBagitSNeighbour";
    ShippingMethod["DHLeCommerceParcelBagitMNeighbour"] = "DeliveryDHLeCommerceParcelBagitMNeighbour";
    ShippingMethod["DHLeCommerceWorldwideAir"] = "DeliveryDHLeCommerceWorldwideAir";
    ShippingMethod["DHLeCommerceParcelInternational"] = "DeliveryDHLeCommerceParcelInternational";
    ShippingMethod["DHLeCommerceParcel"] = "DeliveryDHLeCommerceParcel";
    ShippingMethod["DHLeCommerceNextDayNeighbour"] = "DeliveryDHLeCommerceNextDayNeighbour";
    ShippingMethod["DHLeCommerceNextDayDoorstep"] = "DeliveryDHLeCommerceNextDayDoorstep";
    ShippingMethod["DHLeCommerceNextDayLeaveSafe"] = "DeliveryDHLeCommerceNextDayLeaveSafe";
    ShippingMethod["DHLeCommerceNextDay1200Neighbour"] = "DeliveryDHLeCommerceNextDay1200Neighbour";
    ShippingMethod["DHLeCommerceNextDay1200Doorstep"] = "DeliveryDHLeCommerceNextDay1200Doorstep";
    ShippingMethod["DHLeCommerceNextDay1200LeaveSafe"] = "DeliveryDHLeCommerceNextDay1200LeaveSafe";
    ShippingMethod["DHLeCommerceNextDay1030Neighbour"] = "DeliveryDHLeCommerceNextDay1030Neighbour";
    ShippingMethod["DHLeCommerceNextDay1030Doorstep"] = "DeliveryDHLeCommerceNextDay1030Doorstep";
    ShippingMethod["DHLeCommerceNextDay1030LeaveSafe"] = "DeliveryDHLeCommerceNextDay1030LeaveSafe";
    ShippingMethod["DHLeCommerceNextDay0900Doorstep"] = "DeliveryDHLeCommerceNextDay0900Doorstep";
    ShippingMethod["DHLeCommerceSaturdayNeighbour"] = "DeliveryDHLeCommerceSaturdayNeighbour";
    ShippingMethod["DHLeCommerceSaturdayDoorstep"] = "DeliveryDHLeCommerceSaturdayDoorstep";
    ShippingMethod["DHLeCommerceSaturdayLeaveSafe"] = "DeliveryDHLeCommerceSaturdayLeaveSafe";
    ShippingMethod["DHLeCommerceSaturday1030Neighbour"] = "DeliveryDHLeCommerceSaturday1030Neighbour";
    ShippingMethod["DHLeCommerceSaturday1030Doorstep"] = "DeliveryDHLeCommerceSaturday1030Doorstep";
    ShippingMethod["DHLeCommerceSaturday1030LeaveSafe"] = "DeliveryDHLeCommerceSaturday1030LeaveSafe";
    ShippingMethod["DHLeCommerceSaturday0900Doorstep"] = "DeliveryDHLeCommerceSaturday0900Doorstep";
    ShippingMethod["DHLeCommerce48HourNeighbour"] = "DeliveryDHLeCommerce48HourNeighbour";
    ShippingMethod["DHLeCommerce72HourLeaveSafe"] = "DeliveryDHLeCommerce72HourLeaveSafe";
    ShippingMethod["UPSStandard"] = "DeliveryUPSStandard";
    ShippingMethod["UPSNextDayAir"] = "DeliveryUPSNextDayAir";
    ShippingMethod["UPS2Day"] = "DeliveryUPS2Day";
    ShippingMethod["UPSGround"] = "DeliveryUPSGround";
    ShippingMethod["UPSExpress"] = "DeliveryUPSExpress";
    ShippingMethod["UPSExpedited"] = "DeliveryUPSExpedited";
    ShippingMethod["UPS3DaySelect"] = "DeliveryUPS3DaySelect";
    ShippingMethod["UPSNextDayAirSaver"] = "DeliveryUPSNextDayAirSaver";
    ShippingMethod["UPSNextDayAirEarly"] = "DeliveryUPSNextDayAirEarly";
    ShippingMethod["UPSWorldwideEconomyDDU"] = "DeliveryUPSWorldwideEconomyDDU";
    ShippingMethod["UPSExpressPlus"] = "DeliveryUPSExpressPlus";
    ShippingMethod["UPS2DayAirAM"] = "DeliveryUPS2DayAirAM";
    ShippingMethod["UPSSaver"] = "DeliveryUPSSaver";
    ShippingMethod["UPSFirstClassMail"] = "DeliveryUPSFirstClassMail";
    ShippingMethod["UPSPriorityMail"] = "DeliveryUPSPriorityMail";
    ShippingMethod["UPSExpeditedMailInnovations"] = "DeliveryUPSExpeditedMailInnovations";
    ShippingMethod["UPSPriorityMailInnovations"] = "DeliveryUPSPriorityMailInnovations";
    ShippingMethod["UPSEconomyMailInnovations"] = "DeliveryUPSEconomyMailInnovations";
    ShippingMethod["UPSMailInnovationsMIReturns"] = "DeliveryUPSMailInnovationsMIReturns";
    ShippingMethod["UPSAccessPointEconomy"] = "DeliveryUPSAccessPointEconomy";
    ShippingMethod["UPSWorldwideExpressFreightMidday"] = "DeliveryUPSWorldwideExpressFreightMidday";
    ShippingMethod["UPSWorldwideEconomyDDP"] = "DeliveryUPSWorldwideEconomyDDP";
    ShippingMethod["UPSExpress1200"] = "DeliveryUPSExpress1200";
    ShippingMethod["UPSHeavyGoods"] = "DeliveryUPSHeavyGoods";
    ShippingMethod["UPSTodayStandard"] = "DeliveryUPSTodayStandard";
    ShippingMethod["UPSTodayDedicatedCourier"] = "DeliveryUPSTodayDedicatedCourier";
    ShippingMethod["UPSTodayIntercity"] = "DeliveryUPSTodayIntercity";
    ShippingMethod["UPSTodayExpress"] = "DeliveryUPSTodayExpress";
    ShippingMethod["UPSTodayExpressSaver"] = "DeliveryUPSTodayExpressSaver";
    ShippingMethod["UPSWorldwideExpressFreight"] = "DeliveryUPSWorldwideExpressFreight";
    ShippingMethod["UPSRoadieXDAM"] = "DeliveryUPSRoadieXDAM";
    ShippingMethod["UPSRoadieXDPM"] = "DeliveryUPSRoadieXDPM";
    ShippingMethod["UPSRoadieXD"] = "DeliveryUPSRoadieXD";
    ShippingMethod["AGLDHLeCommerce48"] = "DeliveryAGLDHLeCommerce48";
    ShippingMethod["AGLParcelsNextDay"] = "DeliveryAGLParcelsNextDay";
    ShippingMethod["AGLParcelsNextDay1200"] = "DeliveryAGLParcelsNextDay1200";
    ShippingMethod["AGLParcelsNextDay0900"] = "DeliveryAGLParcelsNextDay0900";
    ShippingMethod["AGLBagitXLNextDay"] = "DeliveryAGLBagitXLNextDay";
    ShippingMethod["AGLBagitLargeNextDay"] = "DeliveryAGLBagitLargeNextDay";
    ShippingMethod["AGLBagitMediumNextDay"] = "DeliveryAGLBagitMediumNextDay";
    ShippingMethod["AGLBagitMediumTimedDelivery"] = "DeliveryAGLBagitMediumTimedDelivery";
    ShippingMethod["AGLBagitSmallNextDay"] = "DeliveryAGLBagitSmallNextDay";
    ShippingMethod["AGLParcels48Hour"] = "DeliveryAGLParcels48Hour";
    ShippingMethod["AGLParcels48HourB2C"] = "DeliveryAGLParcels48HourB2C";
    ShippingMethod["AGLParcels48HourPlus"] = "DeliveryAGLParcels48HourPlus";
    ShippingMethod["AGLParcelsNextDayIOD"] = "DeliveryAGLParcelsNextDayIOD";
    ShippingMethod["AGLParcelsNextDay1200IOD"] = "DeliveryAGLParcelsNextDay1200IOD";
    ShippingMethod["AGLParcelsNextDay1030IOD"] = "DeliveryAGLParcelsNextDay1030IOD";
    ShippingMethod["AGLParcelsNextDayPOD"] = "DeliveryAGLParcelsNextDayPOD";
    ShippingMethod["AGLBagitSLeaveSafe"] = "DeliveryAGLBagitSLeaveSafe";
    ShippingMethod["AGLBagitSmallNextDayPOD"] = "DeliveryAGLBagitSmallNextDayPOD";
    ShippingMethod["AGLBagitMediumNextDayPOD"] = "DeliveryAGLBagitMediumNextDayPOD";
    ShippingMethod["AGLBagitLargeNextDayPOD"] = "DeliveryAGLBagitLargeNextDayPOD";
    ShippingMethod["AGLBagitXLNextDayPOD"] = "DeliveryAGLBagitXLNextDayPOD";
    ShippingMethod["AGLBagitMLeaveSafe"] = "DeliveryAGLBagitMLeaveSafe";
    ShippingMethod["AGLBagitLLeaveSafe"] = "DeliveryAGLBagitLLeaveSafe";
    ShippingMethod["AddressOnlyLabel"] = "DeliveryAddressOnlyLabel";
    ShippingMethod["AddressOnlyRoad"] = "DeliveryAddressOnlyRoad";
    ShippingMethod["AddressOnlyRGSRoad"] = "DeliveryAddressOnlyRGSRoad";
    ShippingMethod["AddressOnlyPalletService"] = "DeliveryAddressOnlyPalletService";
    ShippingMethod["AddressOnlyDHLManual"] = "DeliveryAddressOnlyDHLManual";
    ShippingMethod["AddressOnlyFedexManual"] = "DeliveryAddressOnlyFedexManual";
    ShippingMethod["AddressOnlyRoyalMailManual"] = "DeliveryAddressOnlyRoyalMailManual";
    ShippingMethod["AddressOnlyTNTManual"] = "DeliveryAddressOnlyTNTManual";
    ShippingMethod["IntersoftAmazonDHLExpressUKMFNEconomy"] = "DeliveryIntersoftAmazonDHLExpressUKMFNEconomy";
    ShippingMethod["IntersoftAmazonDPDDEPTPPrimeStdDom"] = "DeliveryIntersoftAmazonDPDDEPTPPrimeStdDom";
    ShippingMethod["IntersoftAmazonDPDUKMFNClassicEU"] = "DeliveryIntersoftAmazonDPDUKMFNClassicEU";
    ShippingMethod["IntersoftAmazonDPDUKMFNPak"] = "DeliveryIntersoftAmazonDPDUKMFNPak";
    ShippingMethod["IntersoftAmazonDPDUKMFNParcelSat"] = "DeliveryIntersoftAmazonDPDUKMFNParcelSat";
    ShippingMethod["IntersoftAmazonDPDUKMFNParcel"] = "DeliveryIntersoftAmazonDPDUKMFNParcel";
    ShippingMethod["IntersoftAmazonHermesUKMFNTwoDayDropOff"] = "DeliveryIntersoftAmazonHermesUKMFNTwoDayDropOff";
    ShippingMethod["IntersoftAmazonHermesUKMFNStandardDropOff"] = "DeliveryIntersoftAmazonHermesUKMFNStandardDropOff";
    ShippingMethod["IntersoftAmazonHermesUKMFNPakSat"] = "DeliveryIntersoftAmazonHermesUKMFNPakSat";
    ShippingMethod["IntersoftAmazonRoyalMailPTPFirstClassLetter"] = "DeliveryIntersoftAmazonRoyalMailPTPFirstClassLetter";
    ShippingMethod["IntersoftAmazonRoyalMailPTPFirstClassLargeLetter"] = "DeliveryIntersoftAmazonRoyalMailPTPFirstClassLargeLetter";
    ShippingMethod["IntersoftAmazonRoyalMailPTPFirstClassSmallParcel"] = "DeliveryIntersoftAmazonRoyalMailPTPFirstClassSmallParcel";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSecondClassLetter"] = "DeliveryIntersoftAmazonRoyalMailPTPSecondClassLetter";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSecondClassLargeLetter"] = "DeliveryIntersoftAmazonRoyalMailPTPSecondClassLargeLetter";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSecondClassSmallParcel"] = "DeliveryIntersoftAmazonRoyalMailPTPSecondClassSmallParcel";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSignedForFirstClassLetter"] = "DeliveryIntersoftAmazonRoyalMailPTPSignedForFirstClassLetter";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSignedForFirstClassLargeLetter"] = "DeliveryIntersoftAmazonRoyalMailPTPSignedForFirstClassLargeLetter";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSignedForFirstClassSmallParcel"] = "DeliveryIntersoftAmazonRoyalMailPTPSignedForFirstClassSmallParcel";
    ShippingMethod["IntersoftAmazonRoyalMailRM24FirstClassLargeLetter"] = "DeliveryIntersoftAmazonRoyalMailRM24FirstClassLargeLetter";
    ShippingMethod["IntersoftAmazonRoyalMailRM24FirstClassParcel"] = "DeliveryIntersoftAmazonRoyalMailRM24FirstClassParcel";
    ShippingMethod["IntersoftAmazonRoyalMailMFNTracked24"] = "DeliveryIntersoftAmazonRoyalMailMFNTracked24";
    ShippingMethod["IntersoftAmazonRoyalMailMFNTracked24LBT"] = "DeliveryIntersoftAmazonRoyalMailMFNTracked24LBT";
    ShippingMethod["IntersoftAmazonRoyalMailMFNTracked48"] = "DeliveryIntersoftAmazonRoyalMailMFNTracked48";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSecondClassMediumParcel"] = "DeliveryIntersoftAmazonRoyalMailPTPSecondClassMediumParcel";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSpecialDeliveryDropOff"] = "DeliveryIntersoftAmazonRoyalMailPTPSpecialDeliveryDropOff";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSignedForFirstClassMediumParcel"] = "DeliveryIntersoftAmazonRoyalMailPTPSignedForFirstClassMediumParcel";
    ShippingMethod["IntersoftAmazonRoyalMailPTPFirstClassMediumParcel"] = "DeliveryIntersoftAmazonRoyalMailPTPFirstClassMediumParcel";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSignedForSecondClassMediumParcel"] = "DeliveryIntersoftAmazonRoyalMailPTPSignedForSecondClassMediumParcel";
    ShippingMethod["IntersoftAmazonRoyalMailMFNTracked48LBT"] = "DeliveryIntersoftAmazonRoyalMailMFNTracked48LBT";
    ShippingMethod["IntersoftAmazonHermesUKMFNNextDay"] = "DeliveryIntersoftAmazonHermesUKMFNNextDay";
    ShippingMethod["IntersoftAmazonHermesUKMFNStandard"] = "DeliveryIntersoftAmazonHermesUKMFNStandard";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSignedForSecondClassLetter"] = "DeliveryIntersoftAmazonRoyalMailPTPSignedForSecondClassLetter";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSignedForSecondClassLargeLetter"] = "DeliveryIntersoftAmazonRoyalMailPTPSignedForSecondClassLargeLetter";
    ShippingMethod["IntersoftAmazonRoyalMailPTPSignedForSecondClassSmallParcel"] = "DeliveryIntersoftAmazonRoyalMailPTPSignedForSecondClassSmallParcel";
    ShippingMethod["IntersoftAmazonOneDayTrackedOff"] = "DeliveryIntersoftAmazonOneDayTrackedOff";
    ShippingMethod["IntersoftAmazonTwoDayTrackedOff"] = "DeliveryIntersoftAmazonTwoDayTrackedOff";
    ShippingMethod["IntersoftAmazonStandardTrackedOn"] = "DeliveryIntersoftAmazonStandardTrackedOn";
    ShippingMethod["IntersoftAmazonOneDayTrackedOn"] = "DeliveryIntersoftAmazonOneDayTrackedOn";
    ShippingMethod["IntersoftAmazonTwoDayTrackedOn"] = "DeliveryIntersoftAmazonTwoDayTrackedOn";
})(ShippingMethod = exports.ShippingMethod || (exports.ShippingMethod = {}));
exports.HumanizeShippingMethod = (_h = {},
    _h[ShippingMethod.Unknown] = 'Unknown',
    _h[ShippingMethod.Delivery] = 'Delivery',
    _h[ShippingMethod.Collection] = 'Collection',
    _h[ShippingMethod.UKNextDayTracked] = 'DPD Next Day',
    _h[ShippingMethod.UKNextDayBefore1030] = 'DPD Next Day (Before 10:30)',
    _h[ShippingMethod.UKNextDayBefore1200] = 'DPD Next Day (Before midday)',
    _h[ShippingMethod.UKNextDaySaturday] = 'DPD Next Day (Saturday)',
    _h[ShippingMethod.UKNextDaySaturdayBefore1030] = 'DPD Next Day (Saturday before 10:30)',
    _h[ShippingMethod.UKNextDaySaturdayBefore1200] = 'DPD Next Day (Saturday before midday)',
    _h[ShippingMethod.DPDTwoDay] = 'DPD Two Day',
    _h[ShippingMethod.DPDAirClassic] = 'DPD Air Classic',
    _h[ShippingMethod.DPDAirExpress] = 'DPD Air Express',
    _h[ShippingMethod.DPDAirLite] = 'DPD Air Lite',
    _h[ShippingMethod.UKFirstClass] = 'RoyalMail UK First Class',
    _h[ShippingMethod.UKFirstClassTracked] = 'RoyalMail UK First Class Tracked',
    _h[ShippingMethod.UKFirstClassTrackedAge] = 'RoyalMail UK First Class Tracked w/ Age Verification',
    _h[ShippingMethod.UKFirstClassTrackedSigned] = 'RoyalMail UK First Class Tracked & Signed',
    _h[ShippingMethod.UKSecondClass] = 'RoyalMail UK Second Class',
    _h[ShippingMethod.UKSecondClassTracked] = 'RoyalMail UK Second Class Tracked',
    _h[ShippingMethod.UKSecondClassTrackedAge] = 'RoyalMail UK Second Class Tracked w/ Age Verification',
    _h[ShippingMethod.UKSecondClassTrackedSigned] = 'RoyalMail UK Second Class Tracked & Signed',
    _h[ShippingMethod.UKSecondClassTrackedReturn] = 'RoyalMail UK Second Class Tracked Return',
    _h[ShippingMethod.UKSpecialDeliveryBy1pm] = 'RoyalMail UK Special Delivery By 1pm',
    _h[ShippingMethod.UKSpecialDeliveryGuaranteed750] = 'RoyalMail Special Delivery Guaranteed (£750)',
    _h[ShippingMethod.UKSpecialDeliveryGuaranteed1000] = 'RoyalMail Special Delivery Guaranteed (£1000)',
    _h[ShippingMethod.UKSpecialDeliveryGuaranteed2500] = 'RoyalMail Special Delivery Guaranteed (£2500)',
    _h[ShippingMethod.InternationalTrackedHeavy] = 'RoyalMail International Tracked Parcels Heavy',
    _h[ShippingMethod.InternationalTrackedHeavyExtraComp] = 'RoyalMail International Tracked Parcels Heavy Extra Comp',
    _h[ShippingMethod.InternationalTrackedHeavyPriority] = 'RoyalMail International Tracked Parcels Heavy Priority',
    _h[ShippingMethod.InternationalTrackedSignedOnAccount] = 'RoyalMail International Tracked & Signed On Account',
    _h[ShippingMethod.InternationalStandardOnAccount] = 'RoyalMail International Standard On Account',
    _h[ShippingMethod.InternationalTrackedHeavyPriorityExtraComp] = 'RoyalMail International Tracked Parcels Heavy Priority Extra Comp',
    _h[ShippingMethod.Europe] = 'RoyalMail International Untracked',
    _h[ShippingMethod.EuropeTracked] = 'RoyalMail International Tracked',
    _h[ShippingMethod.EuropeSigned] = 'RoyalMail International Signed',
    _h[ShippingMethod.USTracked] = 'USPS US Standard',
    _h[ShippingMethod.TransglobalInternationalEconomy] = 'Transglobal International Economy',
    _h[ShippingMethod.TransglobalFedExInternationalEconomy] = 'Transglobal FedEx International Economy',
    _h[ShippingMethod.TransglobalUSPSPrint] = 'Transglobal USPS Print',
    _h[ShippingMethod.RestOfWorld] = 'RoyalMail International Untracked',
    _h[ShippingMethod.RestOfWorldTracked] = 'RoyalMail International Tracked',
    _h[ShippingMethod.RestOfWorldSigned] = 'RoyalMail International Signed',
    _h[ShippingMethod.InternationalTrackedPDDP] = 'RoyalMail International Tracked PDDP',
    _h[ShippingMethod.InternationalTrackedSignedPDDP] = 'RoyalMail International Tracked & Signed PDDP',
    _h[ShippingMethod.InternationalUntrackedPDDP] = 'RoyalMail International Untracked PDDP',
    _h[ShippingMethod.InternationalBusinessMailZoneSortPriority] = 'RoyalMail International Business Mail Zone Sort Priority',
    _h[ShippingMethod.InternationalExpress] = 'DHL Express',
    _h[ShippingMethod.DHLEconomySelect] = 'DHL Economy Select',
    _h[ShippingMethod.UKEcoSameDay] = 'HIVED Same Day (London only)',
    _h[ShippingMethod.UKEcoNextDay] = 'HIVED Next Day (London only)',
    _h[ShippingMethod.UKEcoTwoDay] = 'HIVED Two Day (London only)',
    _h[ShippingMethod.FedEx] = 'FedEx International Connect Plus',
    _h[ShippingMethod.FedExNextDay] = 'FedEx Next Day',
    _h[ShippingMethod.FedExInternationalEconomy] = 'FedEx International Economy',
    _h[ShippingMethod.FedExInternationalPriority] = 'FedEx International Priority',
    _h[ShippingMethod.FedExFirst] = 'FedEx First',
    _h[ShippingMethod.FedExPriorityExpress] = 'FedEx Priority Express',
    _h[ShippingMethod.FedExPriority] = 'FedEx Priority',
    _h[ShippingMethod.FedExEconomySelect] = 'FedEx Economy Select',
    _h[ShippingMethod.FedExPriorityExpressFreight] = 'FedEx Priority Express Freight',
    _h[ShippingMethod.FedExPriorityFreight] = 'FedEx Priority Freight',
    _h[ShippingMethod.PackfleetNextDay] = 'Packfleet Next Day (London only)',
    _h[ShippingMethod.CSMEcom] = 'CSM eCom',
    _h[ShippingMethod.CSMEcomPlus] = 'CSM eCom Plus',
    _h[ShippingMethod.CSMEcomExpress] = 'CSM eCom Express',
    _h[ShippingMethod.CSMDHLPaket] = 'CSM DHL Paket',
    _h[ShippingMethod.CSM900] = 'CSM 9',
    _h[ShippingMethod.CSM1030] = 'CSM 10.30',
    _h[ShippingMethod.CSM1200] = 'CSM 12',
    _h[ShippingMethod.CSM2400] = 'CSM 24',
    _h[ShippingMethod.CSMExpress] = 'CSM Express',
    _h[ShippingMethod.CSMEconomy] = 'CSM Economy',
    _h[ShippingMethod.CSMSaturday] = 'CSM Saturday',
    _h[ShippingMethod.CSMSaturday1200] = 'CSM Saturday 12:00',
    _h[ShippingMethod.CSMSaturday1030] = 'CSM Saturday 10:30',
    _h[ShippingMethod.CSMSunday] = 'CSM Sunday',
    _h[ShippingMethod.CSMSunday1200] = 'CSM Sunday 12:00',
    _h[ShippingMethod.APCNextDayBy9] = 'APC Next Day by 9am',
    _h[ShippingMethod.APCNextDayBy10] = 'APC Next Day by 10am',
    _h[ShippingMethod.APCNextDayBy12] = 'APC Next Day by 12pm',
    _h[ShippingMethod.APCNextDayBy16] = 'APC Next Day by 4pm',
    _h[ShippingMethod.APCTwoToFiveDay] = 'APC 2-5 Day',
    _h[ShippingMethod.APCSaturdayBy9] = 'APC Saturday by 9am',
    _h[ShippingMethod.APCSaturdayBy10] = 'APC Saturday by 10am',
    _h[ShippingMethod.APCSaturdayBy12] = 'APC Saturday by 12pm',
    _h[ShippingMethod.APCLiquidBy10] = 'APC Liquid by 10am',
    _h[ShippingMethod.APCLiquidBy12] = 'APC Liquid by 12pm',
    _h[ShippingMethod.APCLiquidBy16] = 'APC Liquid by 4pm',
    _h[ShippingMethod.APCCourierPackBy10] = 'APC Courier Pack by 10am',
    _h[ShippingMethod.APCCourierPackBy12] = 'APC Courier Pack by 12pm',
    _h[ShippingMethod.APCCourierPackBy16] = 'APC Courier Pack by 4pm',
    _h[ShippingMethod.Samos] = 'Samos',
    _h[ShippingMethod.MaerskParcelPremium] = 'Maersk Parcel Premium',
    _h[ShippingMethod.MaerskParcelPremiumFML] = 'Maersk Parcel Premium FML',
    _h[ShippingMethod.MaerskParcelPlus] = 'Maersk Parcel Plus',
    _h[ShippingMethod.MaerskParcelLiteLarge] = 'Maersk Parcel Lite Large',
    _h[ShippingMethod.MaerskParcelExpressPlus] = 'Maersk Parcel Express Plus',
    _h[ShippingMethod.EvriStandard] = 'Evri Standard',
    _h[ShippingMethod.EvriNextDay] = 'Evri Next Day',
    _h[ShippingMethod.FedexConnectTrackedWorldwide] = 'Fedex International Tracked Worldwide',
    _h[ShippingMethod.APCNonConveyableBy9] = 'APC Non Conveyable by 9am',
    _h[ShippingMethod.APCNonConveyableBy10] = 'APC Non Conveyable by 10am',
    _h[ShippingMethod.APCNonConveyableBy12] = 'APC Non Conveyable by 12pm',
    _h[ShippingMethod.APCNonConveyableBy16] = 'APC Non Conveyable by 4pm',
    _h[ShippingMethod.AnPostExpress] = 'AnPost Express',
    _h[ShippingMethod.AnPostExpressWithSignature] = 'AnPost Express with Signature',
    _h[ShippingMethod.AnPostPriorityParcel] = 'AnPost Priority Parcel',
    _h[ShippingMethod.AnPostEMSParcel] = 'AnPost EMS Parcel',
    _h[ShippingMethod.AnPostStandard] = 'AnPost Standard',
    _h[ShippingMethod.WhistlAmazonPremiumLargeLetter] = 'Whistl Amazon Premium Large Letter',
    _h[ShippingMethod.WhistlAmazonPremiumLargeParcel] = 'Whistl Amazon Premium Large Parcel',
    _h[ShippingMethod.WhistlAmazonPremiumMediumParcel] = 'Whistl Amazon Premium Medium Parcel',
    _h[ShippingMethod.WhistlAmazonPremiumSmallParcel] = 'Whistl Amazon Premium Small Parcel',
    _h[ShippingMethod.WhistlAmazonPremiumStandardParcel] = 'Whistl Amazon Premium Standard Parcel',
    _h[ShippingMethod.WhistlAmazonPremiumXLargeParcel] = 'Whistl Amazon Premium X Large Parcel',
    _h[ShippingMethod.WhistlAmazonStandardLargeLetter] = 'Whistl Amazon Standard Large Letter',
    _h[ShippingMethod.WhistlAmazonStandardLargeParcel] = 'Whistl Amazon Standard Large Parcel',
    _h[ShippingMethod.WhistlAmazonStandardMediumParcel] = 'Whistl Amazon Standard Medium Parcel',
    _h[ShippingMethod.WhistlAmazonStandardSmallParcel] = 'Whistl Amazon Standard Small Parcel',
    _h[ShippingMethod.WhistlAmazonStandardStandardParcel] = 'Whistl Amazon Standard Standard Parcel',
    _h[ShippingMethod.WhistlAmazonStandardXLargeParcel] = 'Whistl Amazon Standard X Large Parcel',
    _h[ShippingMethod.WhistlDPDExpressPak] = 'Whistl DPD ExpressPak',
    _h[ShippingMethod.WhistlDPDExpressPak1030] = 'Whistl DPD ExpressPak 10:30',
    _h[ShippingMethod.WhistlDPDExpressPak1200] = 'Whistl DPD ExpressPak 12:00',
    _h[ShippingMethod.WhistlDPDExpressPakNextDay] = 'Whistl DPD ExpressPak Next Day',
    _h[ShippingMethod.WhistlDPDExpressPakSat1030] = 'Whistl DPD ExpressPak Saturday 10:30',
    _h[ShippingMethod.WhistlDPDExpressPakSat1200] = 'Whistl DPD ExpressPak Saturday 12:00',
    _h[ShippingMethod.WhistlDPDExpressPakSaturday] = 'Whistl DPD ExpressPak Saturday',
    _h[ShippingMethod.WhistlDPDExpressPakSun1030] = 'Whistl DPD ExpressPak Sunday 10:30',
    _h[ShippingMethod.WhistlDPDExpressPakSun1200] = 'Whistl DPD ExpressPak Sunday 12:00',
    _h[ShippingMethod.WhistlDPDExpressPakSunday] = 'Whistl DPD ExpressPak Sunday',
    _h[ShippingMethod.WhistlDPDParcel] = 'Whistl DPD Parcel',
    _h[ShippingMethod.WhistlDPDParcel1030] = 'Whistl DPD Parcel 10:30',
    _h[ShippingMethod.WhistlDPDParcel1200] = 'Whistl DPD Parcel 12:00',
    _h[ShippingMethod.WhistlDPDParcelNextDay] = 'Whistl DPD Parcel Next Day',
    _h[ShippingMethod.WhistlDPDParcelSat1030] = 'Whistl DPD Parcel Saturday 10:30',
    _h[ShippingMethod.WhistlDPDParcelSat1200] = 'Whistl DPD Parcel Saturday 12:00',
    _h[ShippingMethod.WhistlDPDParcelSaturday] = 'Whistl DPD Parcel Saturday',
    _h[ShippingMethod.WhistlDPDParcelSun1200] = 'Whistl DPD Parcel Sunday 12:00',
    _h[ShippingMethod.WhistlDPDParcelSunday] = 'Whistl DPD Parcel Sunday',
    _h[ShippingMethod.WhistlDPDParcelTwoDay] = 'Whistl DPD Parcel Two Day',
    _h[ShippingMethod.WhistlEvriLightLargeNPOD] = 'Whistl Evri Light Large NPOD',
    _h[ShippingMethod.WhistlEvriLightLargePOD] = 'Whistl Evri Light Large POD',
    _h[ShippingMethod.WhistlEvriPacketNextDayNPOD] = 'Whistl Evri Packet Next Day NPOD',
    _h[ShippingMethod.WhistlEvriPacketNextDayPOD] = 'Whistl Evri Packet Next Day POD',
    _h[ShippingMethod.WhistlEvriPacketNPOD] = 'Whistl Evri Packet NPOD',
    _h[ShippingMethod.WhistlEvriPacketPOD] = 'Whistl Evri Packet POD',
    _h[ShippingMethod.WhistlEvriParcelNextDayNPOD] = 'Whistl Evri Parcel Next Day NPOD',
    _h[ShippingMethod.WhistlEvriParcelNextDayPOD] = 'Whistl Evri Parcel Next Day POD',
    _h[ShippingMethod.WhistlEvriParcelNPOD] = 'Whistl Evri Parcel NPOD',
    _h[ShippingMethod.WhistlEvriParcelPOD] = 'Whistl Evri Parcel POD',
    _h[ShippingMethod.WhistlExelotExpediteLightFML] = 'Whistl Exelot Expedite Light FML',
    _h[ShippingMethod.WhistlExelotExpediteLightBPMFML] = 'Whistl Exelot Expedite Light BPM FML',
    _h[ShippingMethod.WhistlExelotExpediteMediaFML] = 'Whistl Exelot Expedite Media FML',
    _h[ShippingMethod.WhistlRoyalMailTracked24HVNONPOD] = 'Whistl RoyalMail Tracked 24 HV NON POD',
    _h[ShippingMethod.WhistlRoyalMailTracked24HVPOD] = 'Whistl RoyalMail Tracked 24 HV POD',
    _h[ShippingMethod.WhistlRoyalMailTracked24LBTHVNONPOD] = 'Whistl RoyalMail Tracked 24 LBT HV NON POD',
    _h[ShippingMethod.WhistlRoyalMailTracked24LBTHVPOD] = 'Whistl RoyalMail Tracked 24 LBT HV POD',
    _h[ShippingMethod.WhistlRoyalMailTracked24Returns] = 'Whistl RoyalMail Tracked 24 Returns',
    _h[ShippingMethod.WhistlRoyalMailTracked48HVNONPOD] = 'Whistl RoyalMail Tracked 48 HV NON POD',
    _h[ShippingMethod.WhistlRoyalMailTracked48LBTHVNONPOD] = 'Whistl RoyalMail Tracked 48 LBT HV NON POD',
    _h[ShippingMethod.WhistlRoyalMailTracked48LBTHVPOD] = 'Whistl RoyalMail Tracked 48 LBT HV POD',
    _h[ShippingMethod.WhistlRoyalMailTracked48Returns] = 'Whistl RoyalMail Tracked 48 Returns',
    _h[ShippingMethod.WhistlRoyalMailTracked48HVPOD] = 'Whistl RoyalMail Tracked 48 HV POD',
    _h[ShippingMethod.WhistlUPSStandardDomestic] = 'Whistl UPS Standard Domestic',
    _h[ShippingMethod.WhistlInSightInSightLargeLetter] = 'Whistl InSight Large Letter',
    _h[ShippingMethod.WhistlInSightInSightPacket] = 'Whistl InSight Packet',
    _h[ShippingMethod.WhistlInSightInternationalInSightInternationalBoxable] = 'Whistl InSight International Boxable',
    _h[ShippingMethod.WhistlInSightInternationalInSightInternationalLargeLetter] = 'Whistl InSight International Large Letter',
    _h[ShippingMethod.WhistlInSightInternationalInSightInternationalPacket] = 'Whistl InSight International Packet',
    _h[ShippingMethod.WhistlPremiumDDPPremiumParcelDDP] = 'Whistl Premium Premium Parcel DDP',
    _h[ShippingMethod.WhistlPremiumDDUPremiumParcelDDU] = 'Whistl Premium Premium Parcel DDU',
    _h[ShippingMethod.WhistlStandardDDUStandardBPMDDU] = 'Whistl Standard BPM DDU',
    _h[ShippingMethod.WhistlStandardDDUStandardParcelDDU] = 'Whistl Standard Parcel DDU',
    _h[ShippingMethod.WhistlStandardDDUStandardParcelDDUIreland] = 'Whistl Standard Parcel DDU Ireland',
    _h[ShippingMethod.WhistlStandardDDUStandardSmallParcelDDU] = 'Whistl Standard Small Parcel DDU',
    _h[ShippingMethod.WhistlStandardIOSSStandardParcelIOSS] = 'Whistl Standard Parcel IOSS',
    _h[ShippingMethod.WhistlStandardIOSSStandardParcelIOSSIreland] = 'Whistl Standard Parcel IOSS Ireland',
    _h[ShippingMethod.WhistlStandardRoadDDPStandardRoadParcelDDP] = 'Whistl Standard Road Parcel DDP',
    _h[ShippingMethod.WhistlStandardRoadDDUStandardRoadParcelDDU] = 'Whistl Standard Road Parcel DDU',
    _h[ShippingMethod.WhistlYodelXPECT24NPOD] = 'Whistl Yodel XPECT 24 NPOD',
    _h[ShippingMethod.WhistlYodelXPECT24POD] = 'Whistl Yodel XPECT 24 POD',
    _h[ShippingMethod.WhistlYodelXPECT48XLNPOD] = 'Whistl Yodel XPECT 48 XL NPOD',
    _h[ShippingMethod.WhistlYodelXPECT48XLPOD] = 'Whistl Yodel XPECT 48 XL POD',
    _h[ShippingMethod.WhistlYodelXPRESS24NPOD] = 'Whistl Yodel XPRESS 24 NPOD',
    _h[ShippingMethod.WhistlYodelXPRESS24POD] = 'Whistl Yodel XPRESS 24 POD',
    _h[ShippingMethod.WhistlYodelXPRESS48NPOD] = 'Whistl Yodel XPRESS 48 NPOD',
    _h[ShippingMethod.WhistlYodelXPRESS48POD] = 'Whistl Yodel XPRESS 48 POD',
    _h[ShippingMethod.WhistlYodelCISTANDARDNPOD] = 'Whistl Yodel CI STANDARD NPOD',
    _h[ShippingMethod.WhistlYodelCISTANDARDPOD] = 'Whistl Yodel CI STANDARD POD',
    _h[ShippingMethod.WhistlYodelXPECTMEDIUM24NONPOD] = 'Whistl Yodel XPECT MEDIUM 24 NON POD',
    _h[ShippingMethod.WhistlYodelXPECTMEDIUM24POD] = 'Whistl Yodel XPECT MEDIUM 24 POD',
    _h[ShippingMethod.WhistlYodelXPECTMEDIUM48NONPOD] = 'Whistl Yodel XPECT MEDIUM 48 NON POD',
    _h[ShippingMethod.WhistlYodelXPECTMEDIUM48POD] = 'Whistl Yodel XPECT MEDIUM 48 POD',
    _h[ShippingMethod.WhistlYodelXPECTMINI24NONPOD] = 'Whistl Yodel XPECT MINI 24 NON POD',
    _h[ShippingMethod.WhistlYodelXPECTMINI24POD] = 'Whistl Yodel XPECT MINI 24 POD',
    _h[ShippingMethod.WhistlYodelXPECTMINI48NONPOD] = 'Whistl Yodel XPECT MINI 48 NON POD',
    _h[ShippingMethod.WhistlYodelXPECT48NPOD] = 'Whistl Yodel XPECT 48NPOD',
    _h[ShippingMethod.WhistlYodelXPECT48POD] = 'Whistl Yodel XPECT 48POD',
    _h[ShippingMethod.WhistlYodelXPECTSATURDAYNPOD] = 'Whistl Yodel XPECT SATURDAY NPOD',
    _h[ShippingMethod.WhistlYodelXPECTSATURDAYPOD] = 'Whistl Yodel XPECT SATURDAY POD',
    _h[ShippingMethod.WhistlYodelXPRESSMINI48NONPOD] = 'Whistl Yodel XPRESS MINI 48 NON POD',
    _h[ShippingMethod.WhistlYodelXPRESSMINI481KGNONPOD] = 'Whistl Yodel XPRESS MINI 48 1KG NON POD',
    _h[ShippingMethod.WhistlLibertyExpressParcelSelect] = 'Whistl Liberty Express Parcel Select',
    _h[ShippingMethod.WhistlLibertyExpressUSPSGroundAdvantage] = 'Whistl Liberty Express USPS Ground Advantage',
    _h[ShippingMethod.WhistlAPGEParcelGSTEUnpaid] = 'Whistl APG EParcel GSTE Unpaid',
    _h[ShippingMethod.WhistlAPGEParcelGSTEPaid] = 'Whistl APG EParcel GSTE Paid',
    _h[ShippingMethod.ProCarrierParcelExpress] = 'Pro Carrier Parcel Express',
    _h[ShippingMethod.ProCarrierParcelPlus] = 'Pro Carrier Parcel Plus',
    _h[ShippingMethod.ProCarrierPacket] = 'Pro Carrier Packet',
    _h[ShippingMethod.ProCarrierParcelPost] = 'Pro Carrier Parcel Post',
    _h[ShippingMethod.ProCarrierParcelUK] = 'Pro Carrier Parcel UK',
    _h[ShippingMethod.ProCarrierNextDay] = 'Pro Carrier Next Day',
    _h[ShippingMethod.ProCarrierNextDayUK] = 'Pro Carrier Next Day UK',
    _h[ShippingMethod.ProCarrierNextDayUK24] = 'Pro Carrier Next Day UK 24',
    _h[ShippingMethod.ProCarrierNextDayUK48] = 'Pro Carrier Next Day UK 48',
    _h[ShippingMethod.ProCarrierUKSaturday] = 'Pro Carrier UK Saturday',
    _h[ShippingMethod.ProCarrierUKSunday] = 'Pro Carrier UK Sunday',
    _h[ShippingMethod.ProCarrierUKBagIt] = 'Pro Carrier UK Bag It',
    _h[ShippingMethod.ProCarrierRoyalMailTracked24NoSignature] = 'Pro Carrier Royal Mail Tracked 24 No Signature',
    _h[ShippingMethod.ProCarrierRoyalMailTracked24Signature] = 'Pro Carrier Royal Mail Tracked 24 Signature',
    _h[ShippingMethod.ProCarrierRoyalMailTracked48NoSignature] = 'Pro Carrier Royal Mail Tracked 48 No Signature',
    _h[ShippingMethod.ProCarrierRoyalMailTracked48Signature] = 'Pro Carrier Royal Mail Tracked 48 Signature',
    _h[ShippingMethod.ProCarrierRoyalMailTrackedLetterboxable24NonSignature] = 'Pro Carrier Royal Mail Tracked Letter-boxable 24 Non-Signature',
    _h[ShippingMethod.ProCarrierRoyalMailTrackedLetterboxable24Signature] = 'Pro Carrier Royal Mail Tracked Letterboxable 24 Signature',
    _h[ShippingMethod.ProCarrierRoyalMailTrackedLetterboxable48NonSignature] = 'Pro Carrier Royal Mail Tracked Letterboxable 48 Non-Signature',
    _h[ShippingMethod.ProCarrierRoyalMailTrackedLetterboxable48Signature] = 'Pro Carrier Royal Mail Tracked Letterboxable 48 Signature',
    _h[ShippingMethod.ProCarrierYodelXpect24XXLPOD] = 'Pro Carrier Yodel Xpect 24 XXL POD',
    _h[ShippingMethod.ProCarrierYodelXpect24XXLNonPOD] = 'Pro Carrier Yodel Xpect 24 XXL N.POD',
    _h[ShippingMethod.ProCarrierYodelXpect48XXLPOD] = 'Pro Carrier Yodel Xpect 48 XXL POD',
    _h[ShippingMethod.ProCarrierYodelXpect48XXLNonPOD] = 'Pro Carrier Yodel Xpect 48 XXL N.POD',
    _h[ShippingMethod.ProCarrierYodelWorldPacket] = 'Pro Carrier Yodel World Packet',
    _h[ShippingMethod.ProCarrierYodelWorldParcel] = 'Pro Carrier Yodel World Parcel',
    _h[ShippingMethod.ProCarrierCI48HRPOD] = 'Pro Carrier CI 48 HR POD',
    _h[ShippingMethod.ProCarrierCI48HRNonPOD] = 'Pro Carrier CI 48 HR N.POD',
    _h[ShippingMethod.ProCarrierXpect24MSPOD] = 'Pro Carrier Xpect 24 M-S POD',
    _h[ShippingMethod.ProCarrierXpect24MSNonPOD] = 'Pro Carrier Xpect 24 M-S N.POD',
    _h[ShippingMethod.ProCarrierXpect24MiniNonPOD] = 'Pro Carrier Xpect 24 Mini N.POD',
    _h[ShippingMethod.ProCarrierXpect24MediumPOD] = 'Pro Carrier Xpect 24 Medium POD',
    _h[ShippingMethod.ProCarrierXpect24MediumNonPOD] = 'Pro Carrier Xpect 24 Medium N.POD',
    _h[ShippingMethod.ProCarrierXpect48MiniNonPOD] = 'Pro Carrier Xpect 48 Mini N.POD',
    _h[ShippingMethod.ProCarrierXpect48MSPOD] = 'Pro Carrier Xpect 48 (M-S) POD',
    _h[ShippingMethod.ProCarrierXpect48MSNonPOD] = 'Pro Carrier Xpect 48 (M-S) N.POD',
    _h[ShippingMethod.ProCarrierXpect48MediumPOD] = 'Pro Carrier Xpect 48 Medium POD',
    _h[ShippingMethod.ProCarrierXpect48MediumNonPOD] = 'Pro Carrier Xpect 48 Medium N.POD',
    _h[ShippingMethod.ProCarrierXpect48XLPOD] = 'Pro Carrier Xpect 48 XL POD',
    _h[ShippingMethod.ProCarrierXpect48XLNonPOD] = 'Pro Carrier Xpect 48 XL N.POD',
    _h[ShippingMethod.DHLeCommerceConnectRoad] = 'DHL eCommerce Connect Road',
    _h[ShippingMethod.DHLeCommerceConnectAir] = 'DHL eCommerce Connect Air',
    _h[ShippingMethod.DHLeCommerceParcelInternationalRoadEconomy] = 'DHL eCommerce Parcel International Road Economy',
    _h[ShippingMethod.DHLeCommerceParcelBagitLNeighbour] = 'DHL eCommerce Parcel Bagit L Neighbour',
    _h[ShippingMethod.DHLeCommerceParcelBagitXLNeighbour] = 'DHL eCommerce Parcel Bagit XL Neighbour',
    _h[ShippingMethod.DHLeCommerceParcelBagitSLeaveSafe] = 'DHL eCommerce Parcel Bagit S Leave Safe',
    _h[ShippingMethod.DHLeCommerceParcelBagitMLeaveSafe] = 'DHL eCommerce Parcel Bagit M Leave Safe',
    _h[ShippingMethod.DHLeCommerceParcelBagitLLeaveSafe] = 'DHL eCommerce Parcel Bagit L Leave Safe',
    _h[ShippingMethod.DHLeCommerceParcelLeaveSafe] = 'DHL eCommerce Parcel Leave Safe',
    _h[ShippingMethod.DHLeCommerceParcelBagitS] = 'DHL eCommerce Parcel Bagit S',
    _h[ShippingMethod.DHLeCommerceParcelBagitM] = 'DHL eCommerce Parcel Bagit M',
    _h[ShippingMethod.DHLeCommerceParcelBagitL] = 'DHL eCommerce Parcel Bagit L',
    _h[ShippingMethod.DHLeCommerceParcelBagitXL] = 'DHL eCommerce Parcel Bagit XL',
    _h[ShippingMethod.DHLeCommerceParcelBagitSNeighbour] = 'DHL eCommerce Parcel Bagit S Neighbour',
    _h[ShippingMethod.DHLeCommerceParcelBagitMNeighbour] = 'DHL eCommerce Parcel Bagit M Neighbour',
    _h[ShippingMethod.DHLeCommerceWorldwideAir] = 'DHL eCommerce Worldwide Air',
    _h[ShippingMethod.DHLeCommerceParcelInternational] = 'DHL eCommerce Parcel International',
    _h[ShippingMethod.DHLeCommerceParcel] = 'DHL eCommerce Parcel',
    _h[ShippingMethod.DHLeCommerceNextDayNeighbour] = 'DHL eCommerce Next Day Neighbour',
    _h[ShippingMethod.DHLeCommerceNextDayDoorstep] = 'DHL eCommerce Next Day Doorstep',
    _h[ShippingMethod.DHLeCommerceNextDayLeaveSafe] = 'DHL eCommerce Next Day Leave Safe',
    _h[ShippingMethod.DHLeCommerceNextDay1200Neighbour] = 'DHL eCommerce Next Day 12:00 Neighbour',
    _h[ShippingMethod.DHLeCommerceNextDay1200Doorstep] = 'DHL eCommerce Next Day 12:00 Doorstep',
    _h[ShippingMethod.DHLeCommerceNextDay1200LeaveSafe] = 'DHL eCommerce Next Day 12:00 Leave Safe',
    _h[ShippingMethod.DHLeCommerceNextDay1030Neighbour] = 'DHL eCommerce Next Day 10:30 Neighbour',
    _h[ShippingMethod.DHLeCommerceNextDay1030Doorstep] = 'DHL eCommerce Next Day 10:30 Doorstep',
    _h[ShippingMethod.DHLeCommerceNextDay1030LeaveSafe] = 'DHL eCommerce Next Day 10:30 Leave Safe',
    _h[ShippingMethod.DHLeCommerceNextDay0900Doorstep] = 'DHL eCommerce Next Day 09:00 Doorstep',
    _h[ShippingMethod.DHLeCommerceSaturdayNeighbour] = 'DHL eCommerce Saturday Neighbour',
    _h[ShippingMethod.DHLeCommerceSaturdayDoorstep] = 'DHL eCommerce Saturday Doorstep',
    _h[ShippingMethod.DHLeCommerceSaturdayLeaveSafe] = 'DHL eCommerce Saturday Leave Safe',
    _h[ShippingMethod.DHLeCommerceSaturday1030Neighbour] = 'DHL eCommerce Saturday 10:30 Neighbour',
    _h[ShippingMethod.DHLeCommerceSaturday1030Doorstep] = 'DHL eCommerce Saturday 10:30 Doorstep',
    _h[ShippingMethod.DHLeCommerceSaturday1030LeaveSafe] = 'DHL eCommerce Saturday 10:30 Leave Safe',
    _h[ShippingMethod.DHLeCommerceSaturday0900Doorstep] = 'DHL eCommerce Saturday 09:00 Doorstep',
    _h[ShippingMethod.DHLeCommerce48HourNeighbour] = 'DHL eCommerce 48 Hour Neighbour',
    _h[ShippingMethod.DHLeCommerce72HourLeaveSafe] = 'DHL eCommerce 72 Hour Leave Safe',
    _h[ShippingMethod.UPSStandard] = 'UPS Standard',
    _h[ShippingMethod.UPSNextDayAir] = 'UPS Next Day Air',
    _h[ShippingMethod.UPS2Day] = 'UPS 2nd Day Air',
    _h[ShippingMethod.UPSGround] = 'UPS Ground',
    _h[ShippingMethod.UPSExpress] = 'UPS Express',
    _h[ShippingMethod.UPSExpedited] = 'UPS Expedited',
    _h[ShippingMethod.UPS3DaySelect] = 'UPS 3 Day Select',
    _h[ShippingMethod.UPSNextDayAirSaver] = 'UPS Next Day Air Saver',
    _h[ShippingMethod.UPSNextDayAirEarly] = 'UPS Next Day Air® Early',
    _h[ShippingMethod.UPSWorldwideEconomyDDU] = 'UPS Worldwide Economy DDU',
    _h[ShippingMethod.UPSExpressPlus] = 'UPS Express Plus',
    _h[ShippingMethod.UPS2DayAirAM] = 'UPS 2nd Day Air A.M.',
    _h[ShippingMethod.UPSSaver] = 'UPS Saver',
    _h[ShippingMethod.UPSFirstClassMail] = 'UPS First Class Mail',
    _h[ShippingMethod.UPSPriorityMail] = 'UPS Priority Mail',
    _h[ShippingMethod.UPSExpeditedMailInnovations] = 'UPS Expedited Mail Innovations',
    _h[ShippingMethod.UPSPriorityMailInnovations] = 'UPS Priority Mail Innovations',
    _h[ShippingMethod.UPSEconomyMailInnovations] = 'UPS Economy Mail Innovations',
    _h[ShippingMethod.UPSMailInnovationsMIReturns] = 'UPS Mail Innovations (MI) Returns',
    _h[ShippingMethod.UPSAccessPointEconomy] = 'UPS Access Point™ Economy',
    _h[ShippingMethod.UPSWorldwideExpressFreightMidday] = 'UPS Worldwide Express Freight Midday',
    _h[ShippingMethod.UPSWorldwideEconomyDDP] = 'UPS Worldwide Economy DDP',
    _h[ShippingMethod.UPSExpress1200] = 'UPS Express®12:00',
    _h[ShippingMethod.UPSHeavyGoods] = 'UPS Heavy Goods',
    _h[ShippingMethod.UPSTodayStandard] = 'UPS Today Standard',
    _h[ShippingMethod.UPSTodayDedicatedCourier] = 'UPS Today Dedicated Courier',
    _h[ShippingMethod.UPSTodayIntercity] = 'UPS Today Intercity',
    _h[ShippingMethod.UPSTodayExpress] = 'UPS Today Express',
    _h[ShippingMethod.UPSTodayExpressSaver] = 'UPS Today Express Saver',
    _h[ShippingMethod.UPSWorldwideExpressFreight] = 'UPS Worldwide Express Freight',
    _h[ShippingMethod.UPSRoadieXDAM] = 'UPS Roadie XD AM',
    _h[ShippingMethod.UPSRoadieXDPM] = 'UPS Roadie XD PM',
    _h[ShippingMethod.UPSRoadieXD] = 'UPS Roadie XD',
    _h[ShippingMethod.AGLDHLeCommerce48] = 'AGL DHL eCommerce 48',
    _h[ShippingMethod.AGLParcelsNextDay] = 'AGL Parcels Next Day (POD/Neighbour)',
    _h[ShippingMethod.AGLParcelsNextDay1200] = 'AGL Parcels Next Day 12:00 (POD/Neighbour)',
    _h[ShippingMethod.AGLParcelsNextDay0900] = 'AGL Parcels Next Day 09:00 (POD only)',
    _h[ShippingMethod.AGLBagitXLNextDay] = 'AGL Bagit XL Next Day (POD/Neighbour)',
    _h[ShippingMethod.AGLBagitLargeNextDay] = 'AGL Bagit Large Next Day (POD/Neighbour)',
    _h[ShippingMethod.AGLBagitMediumNextDay] = 'AGL Bagit Medium Next Day (POD/Neighbour)',
    _h[ShippingMethod.AGLBagitMediumTimedDelivery] = 'AGL Bagit Medium Timed Delivery (POD only)',
    _h[ShippingMethod.AGLBagitSmallNextDay] = 'AGL Bagit Small (& Express) Next Day (POD/Neighbour)',
    _h[ShippingMethod.AGLParcels48Hour] = 'AGL Parcels 48 Hour (POD/Neighbour)',
    _h[ShippingMethod.AGLParcels48HourB2C] = 'AGL Parcels 48 Hour (POD/Neighbour) - B2C',
    _h[ShippingMethod.AGLParcels48HourPlus] = 'AGL Parcels 48 Hour+ (IOD)',
    _h[ShippingMethod.AGLParcelsNextDayIOD] = 'AGL Parcels Next Day (IOD)',
    _h[ShippingMethod.AGLParcelsNextDay1200IOD] = 'AGL Parcels Next Day 12:00 (IOD)',
    _h[ShippingMethod.AGLParcelsNextDay1030IOD] = 'AGL Parcels Next Day 10:30 (IOD)',
    _h[ShippingMethod.AGLParcelsNextDayPOD] = 'AGL Parcels Next Day (POD only)',
    _h[ShippingMethod.AGLBagitSLeaveSafe] = 'AGL Bagit S Leave Safe',
    _h[ShippingMethod.AGLBagitSmallNextDayPOD] = 'AGL Bagit Small (& Express) Next Day (POD only)',
    _h[ShippingMethod.AGLBagitMediumNextDayPOD] = 'AGL Bagit Medium Next Day (POD only)',
    _h[ShippingMethod.AGLBagitLargeNextDayPOD] = 'AGL Bagit Large Next Day (POD only)',
    _h[ShippingMethod.AGLBagitXLNextDayPOD] = 'AGL Bagit XL Next Day (POD only)',
    _h[ShippingMethod.AGLBagitMLeaveSafe] = 'AGL Bagit M Leave Safe',
    _h[ShippingMethod.AGLBagitLLeaveSafe] = 'AGL Bagit L Leave Safe',
    _h[ShippingMethod.AddressOnlyLabel] = 'Address Only Label',
    _h[ShippingMethod.AddressOnlyRoad] = 'Address Only Road',
    _h[ShippingMethod.AddressOnlyRGSRoad] = 'Address Only RGS Road',
    _h[ShippingMethod.AddressOnlyPalletService] = 'Address Only Pallet Service',
    _h[ShippingMethod.AddressOnlyDHLManual] = 'Address Only DHL Manual',
    _h[ShippingMethod.AddressOnlyFedexManual] = 'Address Only Fedex Manual',
    _h[ShippingMethod.AddressOnlyRoyalMailManual] = 'Address Only Royal Mail Manual',
    _h[ShippingMethod.AddressOnlyTNTManual] = 'Address Only TNT Manual',
    _h[ShippingMethod.IntersoftAmazonDHLExpressUKMFNEconomy] = 'Amazon DHL Express UK MFN Economy',
    _h[ShippingMethod.IntersoftAmazonDPDDEPTPPrimeStdDom] = 'Amazon DPD ETP Prime Std Dom',
    _h[ShippingMethod.IntersoftAmazonDPDUKMFNClassicEU] = 'Amazon DPD UK MFN Classic EU',
    _h[ShippingMethod.IntersoftAmazonDPDUKMFNPak] = 'Amazon DPD UK MFN Pak',
    _h[ShippingMethod.IntersoftAmazonDPDUKMFNParcelSat] = 'Amazon DPD UK MFN Parcel Sat',
    _h[ShippingMethod.IntersoftAmazonDPDUKMFNParcel] = 'Amazon DPD UK MFN Parcel',
    _h[ShippingMethod.IntersoftAmazonHermesUKMFNTwoDayDropOff] = 'Amazon Hermes UK MFN Two Day Drop Off',
    _h[ShippingMethod.IntersoftAmazonHermesUKMFNStandardDropOff] = 'Amazon Hermes UK MFN Standard Drop Off',
    _h[ShippingMethod.IntersoftAmazonHermesUKMFNPakSat] = 'Amazon Hermes UK MFN Pak Sat',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPFirstClassLetter] = 'Amazon Royal Mail PTP First Class Letter',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPFirstClassLargeLetter] = 'Amazon Royal Mail PTP First Class Large Letter',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPFirstClassSmallParcel] = 'Amazon Royal Mail PTP First Class Small Parcel',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSecondClassLetter] = 'Amazon Royal Mail PTP Second Class Letter',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSecondClassLargeLetter] = 'Amazon Royal Mail PTP Second Class Large Letter',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSecondClassSmallParcel] = 'Amazon Royal Mail PTP Second Class Small Parcel',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSignedForFirstClassLetter] = 'Amazon Royal Mail PTP Signed For First Class Letter',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSignedForFirstClassLargeLetter] = 'Amazon Royal Mail PTP Signed For First Class Large Letter',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSignedForFirstClassSmallParcel] = 'Amazon Royal Mail PTP Signed For First Class Small Parcel',
    _h[ShippingMethod.IntersoftAmazonRoyalMailRM24FirstClassLargeLetter] = 'Amazon Royal Mail RM24 First Class Large Letter',
    _h[ShippingMethod.IntersoftAmazonRoyalMailRM24FirstClassParcel] = 'Amazon Royal Mail RM24 First Class Parcel',
    _h[ShippingMethod.IntersoftAmazonRoyalMailMFNTracked24] = 'Amazon Royal Mail MFN Tracked 24',
    _h[ShippingMethod.IntersoftAmazonRoyalMailMFNTracked24LBT] = 'Amazon Royal Mail MFN Tracked 24 LBT',
    _h[ShippingMethod.IntersoftAmazonRoyalMailMFNTracked48] = 'Amazon Royal Mail MFN Tracked 48',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSecondClassMediumParcel] = 'Amazon Royal Mail PTP Second Class Medium Parcel',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSpecialDeliveryDropOff] = 'Amazon Royal Mail PTP Special Delivery Drop Off',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSignedForFirstClassMediumParcel] = 'Amazon Royal Mail PTP Signed For First Class Medium Parcel',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPFirstClassMediumParcel] = 'Amazon Royal Mail PTP First Class Medium Parcel',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSignedForSecondClassMediumParcel] = 'Amazon Royal Mail PTP Signed For Second Class Medium Parcel',
    _h[ShippingMethod.IntersoftAmazonRoyalMailMFNTracked48LBT] = 'Amazon Royal Mail MFN Tracked 48 LBT',
    _h[ShippingMethod.IntersoftAmazonHermesUKMFNNextDay] = 'Amazon Hermes UK MFN Next Day',
    _h[ShippingMethod.IntersoftAmazonHermesUKMFNStandard] = 'Amazon Hermes UK MFN Standard',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSignedForSecondClassLetter] = 'Amazon Royal Mail PTP Signed For Second Class Letter',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSignedForSecondClassLargeLetter] = 'Amazon Royal Mail PTP Signed For Second Class Large Letter',
    _h[ShippingMethod.IntersoftAmazonRoyalMailPTPSignedForSecondClassSmallParcel] = 'Amazon Royal Mail PTP Signed For Second Class Small Parcel',
    _h[ShippingMethod.IntersoftAmazonOneDayTrackedOff] = 'Amazon Shipping One-Day Tracked (OFF)',
    _h[ShippingMethod.IntersoftAmazonTwoDayTrackedOff] = 'Amazon Shipping Two-Day Tracked (OFF)',
    _h[ShippingMethod.IntersoftAmazonStandardTrackedOn] = 'Amazon Shipping Standard Tracked (ON)',
    _h[ShippingMethod.IntersoftAmazonOneDayTrackedOn] = 'Amazon Shipping One-Day Tracked (ON)',
    _h[ShippingMethod.IntersoftAmazonTwoDayTrackedOn] = 'Amazon Shipping Two-Day Tracked (ON)',
    _h);
var ProductType;
(function (ProductType) {
    ProductType["Unknown"] = "ProductTypeUnknown";
    ProductType["Other"] = "Other";
    ProductType["AlcoholRum"] = "AlcoholRum";
    ProductType["AlcoholWhisky"] = "AlcoholWhisky";
    ProductType["AlcoholGin"] = "AlcoholGin";
    ProductType["AlcoholTequila"] = "AlcoholTequila";
    ProductType["AlcoholVodka"] = "AlcoholVodka";
    ProductType["Apparel"] = "Apparel";
    ProductType["Accessories"] = "Accessories";
    ProductType["AccessoriesSticker"] = "AccessoriesSticker";
    ProductType["AccessoriesCoffeeCup"] = "AccessoriesCoffeeCup";
    ProductType["AccessoriesPoster"] = "AccessoriesPoster";
    ProductType["AccessoriesCandles"] = "AccessoriesCandles";
    ProductType["AccessoriesBag"] = "AccessoriesBag";
    ProductType["AccessoriesTowel"] = "AccessoriesTowel";
    ProductType["AccessoriesHairBonnet"] = "AccessoriesHairBonnet";
    ProductType["AccessoriesHairClips"] = "AccessoriesHairClips";
    ProductType["AccessoriesComb"] = "AccessoriesComb";
    ProductType["AccessoriesNecklace"] = "AccessoriesNecklace";
    ProductType["AccessoriesBangle"] = "AccessoriesBangle";
    ProductType["AccessoriesEarrings"] = "AccessoriesEarrings";
    ProductType["AccessoriesRing"] = "AccessoriesRing";
    ProductType["AccessoriesPhoneCase"] = "AccessoriesPhoneCase";
    ProductType["AccessoriesScissor"] = "AccessoriesScissor";
    ProductType["AccessoriesSunglasses"] = "AccessoriesSunglasses";
    ProductType["AccessoriesFaceMask"] = "AccessoriesFaceMask";
    ProductType["AccessoriesBracelet"] = "AccessoriesBracelet";
    ProductType["AccessoriesWatch"] = "AccessoriesWatch";
    ProductType["AccessoriesWatchBand"] = "AccessoriesWatchBand";
    ProductType["AccessoriesBrush"] = "AccessoriesBrush";
    ProductType["AccessoriesHairExtensions"] = "AccessoriesHairExtensions";
    ProductType["AccessoriesClutch"] = "AccessoriesClutch";
    ProductType["AccessoriesCardHolder"] = "AccessoriesCardHolder";
    ProductType["AccessoriesBottlePump"] = "AccessoriesBottlePump";
    ProductType["AccessoriesCarabiner"] = "AccessoriesCarabiner";
    ProductType["AccessoriesBagStrap"] = "AccessoriesBagStrap";
    ProductType["AccessoriesCutlery"] = "AccessoriesCutlery";
    ProductType["AccessoriesFlaskBottle"] = "AccessoriesFlaskBottle";
    ProductType["Cosmetics"] = "Cosmetics";
    ProductType["CosmeticsDeodorantBalm"] = "CosmeticsDeodorantBalm";
    ProductType["CosmeticsFaceOil"] = "CosmeticsFaceOil";
    ProductType["CosmeticsFaceMask"] = "CosmeticsFaceMask";
    ProductType["CosmeticsCottonPads"] = "CosmeticsCottonPads";
    ProductType["CosmeticsBodyCream"] = "CosmeticsBodyCream";
    ProductType["CosmeticsBodyScrub"] = "CosmeticsBodyScrub";
    ProductType["CosmeticsGel"] = "CosmeticsGel";
    ProductType["CosmeticsBodyWash"] = "CosmeticsBodyWash";
    ProductType["CosmeticsFaceWash"] = "CosmeticsFaceWash";
    ProductType["CosmeticsLipBalm"] = "CosmeticsLipBalm";
    ProductType["CosmeticsFaceCream"] = "CosmeticsFaceCream";
    ProductType["CosmeticsHairShampoo"] = "CosmeticsHairShampoo";
    ProductType["CosmeticsHairOil"] = "CosmeticsHairOil";
    ProductType["CosmeticsHairLotion"] = "CosmeticsHairLotion";
    ProductType["CosmeticsHairConditioner"] = "CosmeticsHairConditioner";
    ProductType["CosmeticsHairSpray"] = "CosmeticsHairSpray";
    ProductType["CosmeticsBalm"] = "CosmeticsBalm";
    ProductType["CosmeticsBeardOil"] = "CosmeticsBeardOil";
    ProductType["CosmeticsBeardConditioner"] = "CosmeticsBeardConditioner";
    ProductType["CosmeticsMascara"] = "CosmeticsMascara";
    ProductType["CosmeticsSyrum"] = "CosmeticsSyrum";
    ProductType["CosmeticsSunScreen"] = "CosmeticsSunScreen";
    ProductType["CosmeticsDermaRoller"] = "CosmeticsDermaRoller";
    ProductType["CosmeticsBodyOil"] = "CosmeticsBodyOil";
    ProductType["CosmeticsToner"] = "CosmeticsToner";
    ProductType["ClothingHoodie"] = "ClothingHoodie";
    ProductType["ClothingSocks"] = "ClothingSocks";
    ProductType["ClothingSwimwear"] = "ClothingSwimwear";
    ProductType["ClothingTShirt"] = "ClothingTShirt";
    ProductType["ClothingJumper"] = "ClothingJumper";
    ProductType["ClothingSportswear"] = "ClothingSportswear";
    ProductType["ClothingDress"] = "ClothingDress";
    ProductType["ClothingLeggings"] = "ClothingLeggings";
    ProductType["ClothingJumpsuit"] = "ClothingJumpsuit";
    ProductType["ClothingTrousers"] = "ClothingTrousers";
    ProductType["ClothingShoes"] = "ClothingShoes";
    ProductType["ClothingPyjamas"] = "ClothingPyjamas";
    ProductType["ClothingSleepMask"] = "ClothingSleepMask";
    ProductType["ClothingScarf"] = "ClothingScarf";
    ProductType["ClothingJacket"] = "ClothingJacket";
    ProductType["ClothingSkirt"] = "ClothingSkirt";
    ProductType["ClothingShorts"] = "ClothingShorts";
    ProductType["ClothingTop"] = "ClothingTop";
    ProductType["ClothingBlazer"] = "ClothingBlazer";
    ProductType["ClothingBelt"] = "ClothingBelt";
    ProductType["ClothingPoloShirt"] = "ClothingPoloShirt";
    ProductType["SnacksGranola"] = "SnacksGranola";
    ProductType["SnacksCrackers"] = "SnacksCrackers";
    ProductType["SnacksBiscuits"] = "SnacksBiscuits";
    ProductType["SnacksCrisps"] = "SnacksCrisps";
    ProductType["SnacksPowderedDrink"] = "SnacksPowderedDrink";
    ProductType["SnacksSeeds"] = "SnacksSeeds";
    ProductType["SnacksJelly"] = "SnacksJelly";
    ProductType["SnacksChocolate"] = "SnacksChocolate";
    ProductType["ElectronicsSafetyAlarm"] = "ElectronicsSafetyAlarm";
    ProductType["ElectronicsToy"] = "ElectronicsToy";
    ProductType["Food"] = "Food";
    ProductType["Book"] = "Book";
    ProductType["DriedTea"] = "DriedTea";
    ProductType["Letter"] = "Letter";
    ProductType["Supplement"] = "Supplement";
    ProductType["Straw"] = "Straw";
    ProductType["ShotGlass"] = "ShotGlass";
    ProductType["EnginePart"] = "EnginePart";
    ProductType["Pen"] = "Pen";
    ProductType["MetalPan"] = "MetalPan";
    ProductType["KeyChain"] = "KeyChain";
    ProductType["GiftCard"] = "GiftCard";
    ProductType["Scissors"] = "Scissors";
    ProductType["BoardGame"] = "BoardGame";
    ProductType["BottleCase"] = "BottleCase";
    ProductType["Newspaper"] = "Newspaper";
    ProductType["Tea"] = "Tea";
    // Addons
    ProductType["Insert"] = "Insert";
    ProductType["Sticker"] = "Sticker";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
exports.ProductTypes = [
    ProductType.Unknown,
    ProductType.Other,
    ProductType.AlcoholRum,
    ProductType.AlcoholWhisky,
    ProductType.AlcoholGin,
    ProductType.AlcoholTequila,
    ProductType.AlcoholVodka,
    // ProductType.Apparel,
    // ProductType.Accessories,
    ProductType.AccessoriesSticker,
    ProductType.AccessoriesCoffeeCup,
    ProductType.AccessoriesPoster,
    ProductType.AccessoriesCandles,
    ProductType.AccessoriesBag,
    ProductType.AccessoriesTowel,
    ProductType.AccessoriesHairBonnet,
    ProductType.AccessoriesHairClips,
    ProductType.AccessoriesComb,
    ProductType.AccessoriesNecklace,
    ProductType.AccessoriesBangle,
    ProductType.AccessoriesEarrings,
    ProductType.AccessoriesRing,
    ProductType.AccessoriesPhoneCase,
    ProductType.AccessoriesScissor,
    ProductType.AccessoriesSunglasses,
    ProductType.AccessoriesFaceMask,
    ProductType.AccessoriesBracelet,
    ProductType.AccessoriesWatch,
    ProductType.AccessoriesWatchBand,
    ProductType.AccessoriesBrush,
    ProductType.AccessoriesHairExtensions,
    ProductType.AccessoriesCardHolder,
    ProductType.AccessoriesBottlePump,
    ProductType.AccessoriesCarabiner,
    ProductType.AccessoriesBagStrap,
    ProductType.AccessoriesCutlery,
    ProductType.AccessoriesFlaskBottle,
    // ProductType.Cosmetics,
    ProductType.CosmeticsDeodorantBalm,
    ProductType.CosmeticsFaceOil,
    ProductType.CosmeticsFaceMask,
    ProductType.CosmeticsCottonPads,
    ProductType.CosmeticsBodyCream,
    ProductType.CosmeticsBodyScrub,
    ProductType.CosmeticsGel,
    ProductType.CosmeticsBodyWash,
    ProductType.CosmeticsFaceWash,
    ProductType.CosmeticsLipBalm,
    ProductType.CosmeticsFaceCream,
    ProductType.CosmeticsHairShampoo,
    ProductType.CosmeticsHairOil,
    ProductType.CosmeticsHairLotion,
    ProductType.CosmeticsHairConditioner,
    ProductType.CosmeticsHairSpray,
    ProductType.CosmeticsBalm,
    ProductType.CosmeticsBeardOil,
    ProductType.CosmeticsBeardConditioner,
    ProductType.CosmeticsMascara,
    ProductType.CosmeticsSyrum,
    ProductType.CosmeticsSunScreen,
    ProductType.CosmeticsDermaRoller,
    ProductType.CosmeticsBodyOil,
    ProductType.CosmeticsToner,
    ProductType.ClothingHoodie,
    ProductType.ClothingSocks,
    ProductType.ClothingSwimwear,
    ProductType.ClothingTShirt,
    ProductType.ClothingJumper,
    ProductType.ClothingSportswear,
    ProductType.ClothingDress,
    ProductType.ClothingLeggings,
    ProductType.ClothingJumpsuit,
    ProductType.ClothingTrousers,
    ProductType.ClothingShoes,
    ProductType.ClothingPyjamas,
    ProductType.ClothingSleepMask,
    ProductType.ClothingScarf,
    ProductType.ClothingJacket,
    ProductType.ClothingSkirt,
    ProductType.ClothingShorts,
    ProductType.ClothingTop,
    ProductType.ClothingBlazer,
    ProductType.ClothingBelt,
    ProductType.ClothingPoloShirt,
    ProductType.SnacksGranola,
    ProductType.SnacksCrackers,
    ProductType.SnacksBiscuits,
    ProductType.SnacksCrisps,
    ProductType.SnacksSeeds,
    ProductType.SnacksJelly,
    ProductType.SnacksChocolate,
    ProductType.SnacksPowderedDrink,
    ProductType.ElectronicsToy,
    ProductType.ElectronicsSafetyAlarm,
    ProductType.Food,
    ProductType.Book,
    ProductType.DriedTea,
    ProductType.Letter,
    ProductType.Supplement,
    ProductType.Straw,
    ProductType.ShotGlass,
    ProductType.EnginePart,
    ProductType.Insert,
    ProductType.Pen,
    ProductType.MetalPan,
    ProductType.KeyChain,
    ProductType.GiftCard,
    ProductType.Scissors,
    ProductType.BoardGame,
    ProductType.BottleCase,
    ProductType.Newspaper,
    ProductType.Tea,
];
exports.HumanizeProductType = (_j = {},
    _j[ProductType.Unknown] = 'Unknown',
    _j[ProductType.Other] = 'Other',
    _j[ProductType.AlcoholRum] = 'Alcohol - Rum',
    _j[ProductType.AlcoholWhisky] = 'Alcohol - Whisky',
    _j[ProductType.AlcoholGin] = 'Alcohol - Gin',
    _j[ProductType.AlcoholTequila] = 'Alcohol - Tequila',
    _j[ProductType.AlcoholVodka] = 'Alcohol - Vodka',
    _j[ProductType.Apparel] = 'Apparel',
    _j[ProductType.Accessories] = 'Accessories',
    _j[ProductType.AccessoriesSticker] = 'Accessories - Sticker',
    _j[ProductType.AccessoriesCoffeeCup] = 'Accessories - Coffee Cup',
    _j[ProductType.AccessoriesPoster] = 'Accessories - Poster',
    _j[ProductType.AccessoriesCandles] = 'Accessories - Candles',
    _j[ProductType.AccessoriesBag] = 'Accessories - Bag',
    _j[ProductType.AccessoriesTowel] = 'Accessories - Towel',
    _j[ProductType.AccessoriesHairBonnet] = 'Accessories - Hair Bonnet',
    _j[ProductType.AccessoriesHairClips] = 'Accessories - Hair Clips',
    _j[ProductType.AccessoriesComb] = 'Accessories - Comb',
    _j[ProductType.AccessoriesNecklace] = 'Accessories - Necklace',
    _j[ProductType.AccessoriesBangle] = 'Accessories - Bangle',
    _j[ProductType.AccessoriesEarrings] = 'Accessories - Earrings',
    _j[ProductType.AccessoriesRing] = 'Accessories - Ring',
    _j[ProductType.AccessoriesPhoneCase] = 'Accessories - Phone Case',
    _j[ProductType.AccessoriesScissor] = 'Accessories - Scissor',
    _j[ProductType.AccessoriesSunglasses] = 'Accessories - Sunglasses',
    _j[ProductType.AccessoriesFaceMask] = 'Accessories - FaceMask',
    _j[ProductType.AccessoriesBracelet] = 'Accessories - Bracelet',
    _j[ProductType.AccessoriesWatch] = 'Accessories - Watch',
    _j[ProductType.AccessoriesWatchBand] = 'Accessories - Watch Band',
    _j[ProductType.AccessoriesBrush] = 'Accessories - Brush',
    _j[ProductType.AccessoriesHairExtensions] = 'Accessories - Hair Extensions',
    _j[ProductType.AccessoriesClutch] = 'Accessories - Clutch',
    _j[ProductType.AccessoriesCardHolder] = 'Accessories - Card Holder',
    _j[ProductType.AccessoriesBottlePump] = 'Accessories - Bottle Pump',
    _j[ProductType.AccessoriesCarabiner] = 'Accessories - Carabiner',
    _j[ProductType.AccessoriesBagStrap] = 'Accessories - Bag Strap',
    _j[ProductType.AccessoriesCutlery] = 'Accessories - Cutlery',
    _j[ProductType.AccessoriesFlaskBottle] = 'Accessories - Flask Bottle',
    _j[ProductType.Cosmetics] = 'Cosmetics',
    _j[ProductType.CosmeticsDeodorantBalm] = 'Cosmetics - Deodorant Balm',
    _j[ProductType.CosmeticsFaceOil] = 'Cosmetics - Face Oil',
    _j[ProductType.CosmeticsFaceMask] = 'Cosmetics - Face Mask',
    _j[ProductType.CosmeticsCottonPads] = 'Cosmetics - Cotton Pads',
    _j[ProductType.CosmeticsBodyCream] = 'Cosmetics - Body Cream',
    _j[ProductType.CosmeticsBodyScrub] = 'Cosmetics - Body Scrub',
    _j[ProductType.CosmeticsGel] = 'Cosmetics - Gel',
    _j[ProductType.CosmeticsBodyWash] = 'Cosmetics - Body Wash',
    _j[ProductType.CosmeticsFaceWash] = 'Cosmetics - Face Wash',
    _j[ProductType.CosmeticsLipBalm] = 'Cosmetics - Lip Balm',
    _j[ProductType.CosmeticsFaceCream] = 'Cosmetics - Face Cream',
    _j[ProductType.CosmeticsHairShampoo] = 'Cosmetics - Hair Shampoo',
    _j[ProductType.CosmeticsHairOil] = 'Cosmetics - Hair Oil',
    _j[ProductType.CosmeticsHairLotion] = 'Cosmetics - Hair Lotion',
    _j[ProductType.CosmeticsHairConditioner] = 'Cosmetics - Hair Conditioner',
    _j[ProductType.CosmeticsHairSpray] = 'Cosmetics - Hair Spray',
    _j[ProductType.CosmeticsBalm] = 'Cosmetics - Balm',
    _j[ProductType.CosmeticsBeardOil] = 'Cosmetics - Beard Oil',
    _j[ProductType.CosmeticsBeardConditioner] = 'Cosmetics - Beard Conditioner',
    _j[ProductType.CosmeticsMascara] = 'Cosmetics - Mascara',
    _j[ProductType.CosmeticsSyrum] = 'Cosmetics - Syrum',
    _j[ProductType.CosmeticsSunScreen] = 'Cosmetics - Sun Screen',
    _j[ProductType.CosmeticsDermaRoller] = 'Cosmetics - Derma Roller',
    _j[ProductType.CosmeticsBodyOil] = 'Cosmetics - Body Oil',
    _j[ProductType.CosmeticsToner] = 'Cosmetics - Toner',
    _j[ProductType.ClothingHoodie] = 'Clothing - Hoodie',
    _j[ProductType.ClothingSocks] = 'Clothing - Socks',
    _j[ProductType.ClothingSwimwear] = 'Clothing - Swimwear',
    _j[ProductType.ClothingTShirt] = 'Clothing - TShirt',
    _j[ProductType.ClothingJumper] = 'Clothing - Jumper',
    _j[ProductType.ClothingSportswear] = 'Clothing - Sportswear',
    _j[ProductType.ClothingDress] = 'Clothing - Dress',
    _j[ProductType.ClothingLeggings] = 'Clothing - Leggings',
    _j[ProductType.ClothingJumpsuit] = 'Clothing - Jumpsuit',
    _j[ProductType.ClothingTrousers] = 'Clothing - Trousers',
    _j[ProductType.ClothingShoes] = 'Clothing - Shoes',
    _j[ProductType.ClothingPyjamas] = 'Clothing - Pyjamas',
    _j[ProductType.ClothingSleepMask] = 'Clothing - Sleep Mask',
    _j[ProductType.ClothingScarf] = 'Clothing - Scarf',
    _j[ProductType.ClothingJacket] = 'Clothing - Jacket',
    _j[ProductType.ClothingSkirt] = 'Clothing - Skirt',
    _j[ProductType.ClothingShorts] = 'Clothing - Shorts',
    _j[ProductType.ClothingTop] = 'Clothing - Top',
    _j[ProductType.ClothingBlazer] = 'Clothing - Blazer',
    _j[ProductType.ClothingBelt] = 'Clothing - Belt',
    _j[ProductType.ClothingPoloShirt] = 'Clothing - Polo Shirt',
    _j[ProductType.SnacksGranola] = 'Snacks - Granola',
    _j[ProductType.SnacksCrackers] = 'Snacks - Crackers',
    _j[ProductType.SnacksBiscuits] = 'Snacks - Biscuits',
    _j[ProductType.SnacksCrisps] = 'Snacks - Crisps',
    _j[ProductType.SnacksPowderedDrink] = 'Snacks - Powdered Drink',
    _j[ProductType.SnacksSeeds] = 'Snacks - Seeds',
    _j[ProductType.SnacksJelly] = 'Snacks - Jelly',
    _j[ProductType.SnacksChocolate] = 'Snacks - Chocolate',
    _j[ProductType.Food] = 'Food',
    _j[ProductType.Book] = 'Misc - Book',
    _j[ProductType.DriedTea] = 'Misc - Dried Tea',
    _j[ProductType.Letter] = 'Misc - Letter',
    _j[ProductType.Supplement] = 'Misc - Supplement',
    _j[ProductType.Straw] = 'Misc - Straw',
    _j[ProductType.ShotGlass] = 'Misc - Shot Glass',
    _j[ProductType.EnginePart] = 'Misc - Engine Part',
    _j[ProductType.ElectronicsToy] = 'Electronics - Toy',
    _j[ProductType.ElectronicsSafetyAlarm] = 'Electronics - Safety Alarm',
    _j[ProductType.Pen] = 'Pen',
    _j[ProductType.MetalPan] = 'Metal Pan',
    _j[ProductType.KeyChain] = 'Key Chain',
    _j[ProductType.GiftCard] = 'Gift Card',
    _j[ProductType.Scissors] = 'Scissors',
    _j[ProductType.BoardGame] = 'Board Game',
    _j[ProductType.BottleCase] = 'Bottle Case',
    _j[ProductType.Newspaper] = 'Newspaper',
    _j[ProductType.Tea] = 'Tea',
    // Addons:
    _j[ProductType.Insert] = 'Insert',
    _j[ProductType.Sticker] = 'Sticker',
    _j);
var PackagingMaterial;
(function (PackagingMaterial) {
    PackagingMaterial["Unknown"] = "PackagingUnknown";
    PackagingMaterial["None"] = "None";
    PackagingMaterial["BubbleWrap"] = "BubbleWrap";
    PackagingMaterial["AirShock"] = "AirShock";
    PackagingMaterial["ExtraLooseFill"] = "ExtraLooseFill";
})(PackagingMaterial = exports.PackagingMaterial || (exports.PackagingMaterial = {}));
exports.PackagingMaterials = [
    PackagingMaterial.None,
    PackagingMaterial.BubbleWrap,
    PackagingMaterial.AirShock,
    PackagingMaterial.ExtraLooseFill,
];
exports.HumanizePackagingMaterial = (_k = {},
    _k[PackagingMaterial.Unknown] = 'Unknown',
    _k[PackagingMaterial.None] = 'None',
    _k[PackagingMaterial.BubbleWrap] = 'Bubble Wrap',
    _k[PackagingMaterial.AirShock] = 'Air Shock',
    _k[PackagingMaterial.ExtraLooseFill] = 'Extra Loose Fill',
    _k);
var OrderChannel;
(function (OrderChannel) {
    OrderChannel["Manual"] = "Manual";
    OrderChannel["Gift"] = "Gift";
    OrderChannel["Return"] = "Return";
    OrderChannel["Issue"] = "Issue";
    OrderChannel["Cratejoy"] = "Cratejoy";
    OrderChannel["Ebay"] = "Ebay";
    OrderChannel["Etsy"] = "Etsy";
    OrderChannel["Magento"] = "Magento";
    OrderChannel["Sellbrite"] = "Sellbrite";
    OrderChannel["Subbly"] = "Subbly";
    OrderChannel["Shopify"] = "Shopify";
    OrderChannel["ShopWired"] = "ShopWired";
    OrderChannel["Squarespace"] = "Squarespace";
    OrderChannel["TikTok"] = "TikTok";
    OrderChannel["Webflow"] = "Webflow";
    OrderChannel["WooCommerce"] = "WooCommerce";
    OrderChannel["Zoho"] = "Zoho";
    OrderChannel["Veeqo"] = "Veeqo";
    OrderChannel["Boots"] = "Boots";
    OrderChannel["NotOnTheHighStreet"] = "NotOnTheHighStreet";
    OrderChannel["Visualsoft"] = "Visualsoft";
    OrderChannel["Xero"] = "Xero";
})(OrderChannel = exports.OrderChannel || (exports.OrderChannel = {}));
exports.OrderChannels = [
    OrderChannel.Manual,
    OrderChannel.Gift,
    OrderChannel.Return,
    OrderChannel.Issue,
    OrderChannel.Cratejoy,
    OrderChannel.Ebay,
    OrderChannel.Etsy,
    OrderChannel.Magento,
    OrderChannel.Sellbrite,
    OrderChannel.Subbly,
    OrderChannel.Shopify,
    OrderChannel.ShopWired,
    OrderChannel.Squarespace,
    OrderChannel.TikTok,
    OrderChannel.Webflow,
    OrderChannel.WooCommerce,
    OrderChannel.Zoho,
    OrderChannel.Veeqo,
    OrderChannel.Boots,
    OrderChannel.NotOnTheHighStreet,
    OrderChannel.Visualsoft,
    OrderChannel.Xero,
];
var BillingMethod;
(function (BillingMethod) {
    BillingMethod["Unspecified"] = "BILLING_METHOD_UNSPECIFIED";
    BillingMethod["Prepayment"] = "BILLING_METHOD_PREPAYMENT";
    BillingMethod["Invoice"] = "BILLING_METHOD_INVOICE";
})(BillingMethod = exports.BillingMethod || (exports.BillingMethod = {}));
exports.BillingMethods = [BillingMethod.Prepayment, BillingMethod.Invoice];
exports.HumanizeBillingMethod = (_l = {},
    _l[BillingMethod.Unspecified] = 'Unspecified',
    _l[BillingMethod.Prepayment] = 'Prepayment',
    _l[BillingMethod.Invoice] = 'Invoice',
    _l);
var ClientType;
(function (ClientType) {
    ClientType["Unspecified"] = "TYPE_UNSPECIFIED";
    ClientType["Fulfilment"] = "TYPE_FULFILMENT";
    ClientType["Software"] = "TYPE_SOFTWARE";
})(ClientType = exports.ClientType || (exports.ClientType = {}));
exports.ClientTypes = [ClientType.Fulfilment, ClientType.Software];
exports.HumanizeClientType = (_m = {},
    _m[ClientType.Unspecified] = 'Unknown',
    _m[ClientType.Fulfilment] = 'Fulfilment',
    _m[ClientType.Software] = 'Software',
    _m);
var ClientStatus;
(function (ClientStatus) {
    ClientStatus["Unspecified"] = "STATUS_UNSPECIFIED";
    ClientStatus["Active"] = "STATUS_ACTIVE";
    ClientStatus["Inactive"] = "STATUS_INACTIVE";
    ClientStatus["Disabled"] = "STATUS_DISABLED";
})(ClientStatus = exports.ClientStatus || (exports.ClientStatus = {}));
exports.ClientStatuses = [ClientStatus.Active, ClientStatus.Inactive, ClientStatus.Disabled];
exports.HumanizeClientStatus = (_o = {},
    _o[ClientStatus.Unspecified] = 'Unknown',
    _o[ClientStatus.Active] = 'Active',
    _o[ClientStatus.Inactive] = 'Inactive',
    _o[ClientStatus.Disabled] = 'Disabled',
    _o);
var FontFamily;
(function (FontFamily) {
    FontFamily["Unknown"] = "FontFamilyUnknown";
    FontFamily["NewYork"] = "NewYork";
    FontFamily["Futura"] = "Futura";
    FontFamily["Montserrat"] = "Montserrat";
    FontFamily["OpenSans"] = "OpenSans";
    FontFamily["UntitledSans"] = "UntitledSans";
    FontFamily["Poppins"] = "Poppins";
})(FontFamily = exports.FontFamily || (exports.FontFamily = {}));
exports.FontFamilies = [
    FontFamily.Unknown,
    FontFamily.NewYork,
    FontFamily.Futura,
    FontFamily.Montserrat,
    FontFamily.OpenSans,
    FontFamily.UntitledSans,
    FontFamily.Poppins,
];
exports.HumanizeFontFamily = (_p = {},
    _p[FontFamily.Unknown] = 'Unset',
    _p[FontFamily.NewYork] = 'New York',
    _p[FontFamily.Futura] = 'Futura',
    _p[FontFamily.Montserrat] = 'Montserrat',
    _p[FontFamily.OpenSans] = 'Open Sans',
    _p[FontFamily.UntitledSans] = 'Untitled Sans',
    _p[FontFamily.Poppins] = 'Poppins',
    _p);
function AddressToString(addr) {
    return Array.from(new Set([addr.name, addr.company, addr.line_one, addr.line_two, addr.city, addr.postcode, addr.country]
        .map(function (x) { return x === null || x === void 0 ? void 0 : x.trim(); })
        .filter(function (x) { return x === null || x === void 0 ? void 0 : x.length; }))).join(', ');
}
exports.AddressToString = AddressToString;
function UserHasRole(user, role) {
    var roles = [{ access_level: AuthAccessLevel.Admin }, role];
    if (role.access_level === AuthAccessLevel.Operative) {
        roles.push(__assign(__assign({}, role), { access_level: AuthAccessLevel.Supervisor }));
        roles.push(__assign(__assign({}, role), { access_level: AuthAccessLevel.Manager }));
    }
    if (role.access_level === AuthAccessLevel.Supervisor) {
        roles.push(__assign(__assign({}, role), { access_level: AuthAccessLevel.Manager }));
    }
    var hasRole = false;
    roles.forEach(function (a) {
        var _a;
        (_a = user.rbac_roles) === null || _a === void 0 ? void 0 : _a.forEach(function (b) {
            if (a.access_level && a.access_level !== b.access_level)
                return;
            if (a.resource_type && a.resource_type !== b.resource_type)
                return;
            if (a.resource_id && a.resource_id !== b.resource_id)
                return;
            hasRole = true;
        });
    });
    return hasRole;
}
exports.UserHasRole = UserHasRole;
var AuthResourceType;
(function (AuthResourceType) {
    AuthResourceType["Unspecified"] = "RESOURCE_TYPE_UNSPECIFIED";
    AuthResourceType["Client"] = "RESOURCE_TYPE_CLIENT";
    AuthResourceType["Operator"] = "RESOURCE_TYPE_OPERATOR";
    AuthResourceType["Site"] = "RESOURCE_TYPE_SITE";
})(AuthResourceType = exports.AuthResourceType || (exports.AuthResourceType = {}));
var AuthAccessLevel;
(function (AuthAccessLevel) {
    AuthAccessLevel["Unspecified"] = "ACCESS_LEVEL_UNSPECIFIED";
    AuthAccessLevel["Client"] = "ACCESS_LEVEL_CLIENT";
    AuthAccessLevel["Operative"] = "ACCESS_LEVEL_OPERATIVE";
    AuthAccessLevel["Supervisor"] = "ACCESS_LEVEL_SUPERVISOR";
    AuthAccessLevel["Manager"] = "ACCESS_LEVEL_MANAGER";
    AuthAccessLevel["Admin"] = "ACCESS_LEVEL_ADMIN";
})(AuthAccessLevel = exports.AuthAccessLevel || (exports.AuthAccessLevel = {}));
exports.AddonTissuePaperColors = ['White', 'Black', 'Brown', 'Orange', 'Pink', 'Green', 'Purple'];
var PickSource;
(function (PickSource) {
    PickSource["Unknown"] = "PICK_SOURCE_UNSPECIFIED";
    PickSource["Frontstock"] = "PICKABLE";
    PickSource["Backstock"] = "BACKSTOCK";
    PickSource["Any"] = "ANY";
})(PickSource = exports.PickSource || (exports.PickSource = {}));
exports.HumanizePickSource = (_q = {},
    _q[PickSource.Unknown] = 'Unknown',
    _q[PickSource.Frontstock] = 'Frontstock',
    _q[PickSource.Backstock] = 'Backstock',
    _q[PickSource.Any] = 'Any',
    _q);
exports.PickSources = [PickSource.Any, PickSource.Frontstock, PickSource.Backstock];
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["Unknown"] = "ProductStatusUnknown";
    ProductStatus["NotReady"] = "NotReady";
    ProductStatus["ReadyDomestic"] = "ReadyDomestic";
    ProductStatus["ReadyInternational"] = "ReadyInternational";
})(ProductStatus = exports.ProductStatus || (exports.ProductStatus = {}));
exports.ProductStatuses = [ProductStatus.NotReady, ProductStatus.ReadyDomestic, ProductStatus.ReadyInternational];
exports.HumanizeProductStatus = (_r = {},
    _r[ProductStatus.Unknown] = 'Unknown',
    _r[ProductStatus.NotReady] = 'Red',
    _r[ProductStatus.ReadyDomestic] = 'Amber',
    _r[ProductStatus.ReadyInternational] = 'Green',
    _r);
var IssueStatus;
(function (IssueStatus) {
    IssueStatus["Unknown"] = "IssueStatusUnknown";
    IssueStatus["Reported"] = "Reported";
    IssueStatus["Active"] = "Active";
    IssueStatus["Resolved"] = "Resolved";
    IssueStatus["Rejected"] = "Rejected";
    IssueStatus["Dismissed"] = "Dismissed";
})(IssueStatus = exports.IssueStatus || (exports.IssueStatus = {}));
exports.IssueStatuses = [
    IssueStatus.Reported,
    IssueStatus.Resolved,
    IssueStatus.Active,
    IssueStatus.Rejected,
    IssueStatus.Dismissed,
];
exports.HumanizeIssueStatus = (_s = {},
    _s[IssueStatus.Unknown] = 'Unknown',
    _s[IssueStatus.Reported] = 'Reported',
    _s[IssueStatus.Active] = 'Approved',
    _s[IssueStatus.Resolved] = 'Resolved',
    _s[IssueStatus.Rejected] = 'Rejected',
    _s[IssueStatus.Dismissed] = 'Dismissed',
    _s);
var IssueReason;
(function (IssueReason) {
    IssueReason["Unknown"] = "ReasonUnknown";
    IssueReason["MissingItems"] = "MissingItems";
    IssueReason["CarrierDamaged"] = "CarrierDamaged";
    IssueReason["CarrierLost"] = "CarrierLost";
    IssueReason["DidNotArrive"] = "DidNotArrive";
    IssueReason["IncorrectItems"] = "IncorrectItems";
    IssueReason["CustomerMistake"] = "CustomerMistake";
    IssueReason["ProductLeaked"] = "ProductLeaked";
    IssueReason["ProductDefective"] = "ProductDefective";
})(IssueReason = exports.IssueReason || (exports.IssueReason = {}));
exports.IssueReasons = [
    IssueReason.CustomerMistake,
    IssueReason.ProductLeaked,
    IssueReason.ProductDefective,
    IssueReason.CarrierDamaged,
    IssueReason.CarrierLost,
    IssueReason.DidNotArrive,
    IssueReason.MissingItems,
    IssueReason.IncorrectItems,
];
exports.HumanizeIssueReason = (_t = {},
    _t[IssueReason.Unknown] = 'Unknown',
    _t[IssueReason.CustomerMistake] = 'Customer mistake',
    _t[IssueReason.CarrierDamaged] = 'Damaged by courier',
    _t[IssueReason.CarrierLost] = 'Lost by courier',
    _t[IssueReason.DidNotArrive] = 'Customer has not received order',
    _t[IssueReason.ProductLeaked] = 'Product leaked in transit',
    _t[IssueReason.ProductDefective] = 'Defective product',
    _t[IssueReason.MissingItems] = 'Items were missing',
    _t[IssueReason.IncorrectItems] = 'Incorrect items were dispatched',
    _t);
var IssueReporter;
(function (IssueReporter) {
    IssueReporter["Unknown"] = "ReporterUnknown";
    IssueReporter["Hutch"] = "Hutch";
    IssueReporter["Client"] = "Client";
    IssueReporter["Customer"] = "Customer";
})(IssueReporter = exports.IssueReporter || (exports.IssueReporter = {}));
exports.IssueReporters = [IssueReporter.Hutch, IssueReporter.Client, IssueReporter.Customer];
exports.HumanizeIssueReporter = (_u = {},
    _u[IssueReporter.Unknown] = 'Unknown',
    _u[IssueReporter.Hutch] = 'Hutch',
    _u[IssueReporter.Client] = 'Client',
    _u[IssueReporter.Customer] = 'Customer',
    _u);
var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["Unknown"] = "ClaimStatusUnknown";
    ClaimStatus["Blocked"] = "Blocked";
    ClaimStatus["Requested"] = "Requested";
    ClaimStatus["Approved"] = "Approved";
    ClaimStatus["Declined"] = "Declined";
    ClaimStatus["Cancelled"] = "Cancelled";
})(ClaimStatus = exports.ClaimStatus || (exports.ClaimStatus = {}));
exports.ClaimStatuses = [
    ClaimStatus.Unknown,
    ClaimStatus.Blocked,
    ClaimStatus.Requested,
    ClaimStatus.Approved,
    ClaimStatus.Declined,
    ClaimStatus.Cancelled,
];
exports.HumanizeClaimStatus = (_v = {},
    _v[ClaimStatus.Unknown] = 'Unset',
    _v[ClaimStatus.Blocked] = 'More Information Required',
    _v[ClaimStatus.Requested] = 'Requested',
    _v[ClaimStatus.Approved] = 'Approved by carrier',
    _v[ClaimStatus.Declined] = 'Declined by carrier',
    _v[ClaimStatus.Cancelled] = 'Resolved',
    _v);
var ReturnStatus;
(function (ReturnStatus) {
    ReturnStatus["Unknown"] = "StatusUnknown";
    ReturnStatus["Expected"] = "Expected";
    ReturnStatus["Received"] = "Received";
    ReturnStatus["Processed"] = "Processed";
    ReturnStatus["Cancelled"] = "Cancelled";
})(ReturnStatus = exports.ReturnStatus || (exports.ReturnStatus = {}));
exports.ReturnStatuses = [
    ReturnStatus.Expected,
    ReturnStatus.Received,
    ReturnStatus.Processed,
    ReturnStatus.Cancelled,
];
exports.HumanizeReturnStatus = (_w = {},
    _w[ReturnStatus.Unknown] = 'Unknown',
    _w[ReturnStatus.Expected] = 'Expected',
    _w[ReturnStatus.Received] = 'Received',
    _w[ReturnStatus.Processed] = 'Processed',
    _w[ReturnStatus.Cancelled] = 'Cancelled',
    _w);
var ReturnReason;
(function (ReturnReason) {
    ReturnReason["Unknown"] = "ReasonUnknown";
    ReturnReason["CustomerInitiated"] = "CustomerInitiated";
    ReturnReason["IncorrectAddress"] = "IncorrectAddress";
    ReturnReason["NoSuchAddress"] = "NoSuchAddress";
    ReturnReason["DamagedInTransit"] = "DamagedInTransit";
    ReturnReason["DeliveryFailed"] = "DeliveryFailed";
    ReturnReason["DeliveryRefused"] = "DeliveryRefused";
    ReturnReason["NotProvided"] = "NotProvided";
    // being depreciated, will be replaced w/ line item level reasons
    ReturnReason["CustomerUnsatisfied"] = "CustomerUnsatisfied";
    ReturnReason["ManufacturerDefect"] = "ManufacturerDefect";
    ReturnReason["WrongSize"] = "WrongSize";
})(ReturnReason = exports.ReturnReason || (exports.ReturnReason = {}));
exports.ReturnReasons = [
    ReturnReason.CustomerInitiated,
    ReturnReason.IncorrectAddress,
    ReturnReason.NoSuchAddress,
    ReturnReason.DamagedInTransit,
    ReturnReason.DeliveryFailed,
    ReturnReason.DeliveryRefused,
    ReturnReason.NotProvided,
];
exports.HumanizeReturnReason = (_x = {},
    _x[ReturnReason.Unknown] = 'Unknown',
    _x[ReturnReason.CustomerInitiated] = 'Customer Initiated',
    _x[ReturnReason.CustomerUnsatisfied] = 'Customers unhappy with product(s)',
    _x[ReturnReason.WrongSize] = 'Wrong size',
    _x[ReturnReason.IncorrectAddress] = 'Incorrect Address',
    _x[ReturnReason.NoSuchAddress] = 'No such address',
    _x[ReturnReason.DamagedInTransit] = 'Damaged in transit',
    _x[ReturnReason.DeliveryFailed] = 'Unable to deliver',
    _x[ReturnReason.DeliveryRefused] = 'Delivery refused',
    _x[ReturnReason.NotProvided] = 'Not provided',
    _x[ReturnReason.ManufacturerDefect] = 'Manufacturer Defect',
    _x);
var ReturnResolution;
(function (ReturnResolution) {
    ReturnResolution["Unknown"] = "ResolutionUnknown";
    ReturnResolution["None"] = "None";
    ReturnResolution["StoreCredit"] = "StoreCredit";
    ReturnResolution["Refunded"] = "Refunded";
    ReturnResolution["Replaced"] = "Replaced";
    ReturnResolution["Other"] = "Other";
})(ReturnResolution = exports.ReturnResolution || (exports.ReturnResolution = {}));
exports.ReturnResolutions = [
    ReturnResolution.None,
    ReturnResolution.StoreCredit,
    ReturnResolution.Refunded,
    ReturnResolution.Replaced,
    ReturnResolution.Other,
];
exports.HumanizeReturnResolution = (_y = {},
    _y[ReturnResolution.Unknown] = 'Unknown',
    _y[ReturnResolution.None] = 'None',
    _y[ReturnResolution.StoreCredit] = 'Store Credit',
    _y[ReturnResolution.Refunded] = 'Refunded',
    _y[ReturnResolution.Replaced] = 'Replaced',
    _y[ReturnResolution.Other] = 'Actioned',
    _y);
var RefundMethod;
(function (RefundMethod) {
    RefundMethod["Unspecified"] = "RefundMethodUnspecified";
    RefundMethod["Cash"] = "Cash";
    RefundMethod["Credit"] = "Credit";
    RefundMethod["Replacement"] = "Replacement";
    RefundMethod["Exchange"] = "Exchange";
})(RefundMethod = exports.RefundMethod || (exports.RefundMethod = {}));
exports.RefundMethods = [RefundMethod.Cash, RefundMethod.Credit, RefundMethod.Replacement];
exports.HumanizeRefundMethod = (_z = {},
    _z[RefundMethod.Unspecified] = 'Unspecified',
    _z[RefundMethod.Cash] = 'Refund',
    _z[RefundMethod.Credit] = 'Store Credit',
    _z[RefundMethod.Replacement] = 'Replacement',
    _z[RefundMethod.Exchange] = 'Exchange',
    _z);
var WROStatus;
(function (WROStatus) {
    WROStatus["Unknown"] = "StatusUnknown";
    WROStatus["Pending"] = "Pending";
    WROStatus["Arrived"] = "Arrived";
    WROStatus["Completed"] = "Completed";
    WROStatus["Cancelled"] = "Cancelled";
})(WROStatus = exports.WROStatus || (exports.WROStatus = {}));
exports.WROStatuses = [WROStatus.Pending, WROStatus.Arrived, WROStatus.Completed, WROStatus.Cancelled];
exports.HumanizeWROStatus = (_0 = {},
    _0[WROStatus.Unknown] = 'Unknown',
    _0[WROStatus.Pending] = 'Awaiting Arrival',
    _0[WROStatus.Arrived] = 'Arrived',
    _0[WROStatus.Completed] = 'Processed',
    _0[WROStatus.Cancelled] = 'Cancelled',
    _0);
var WROPackaging;
(function (WROPackaging) {
    WROPackaging["Unknown"] = "PackagingUnknown";
    WROPackaging["Parcel"] = "Parcel";
    WROPackaging["Crate"] = "Crate";
    WROPackaging["Pallet"] = "Pallet";
    WROPackaging["Container"] = "Container";
})(WROPackaging = exports.WROPackaging || (exports.WROPackaging = {}));
exports.WROPackagings = [WROPackaging.Parcel, WROPackaging.Pallet, WROPackaging.Container];
exports.HumanizeWROPackaging = (_1 = {},
    _1[WROPackaging.Unknown] = 'Unknown',
    _1[WROPackaging.Parcel] = 'Parcel',
    _1[WROPackaging.Crate] = 'Crate',
    _1[WROPackaging.Pallet] = 'Pallet',
    _1[WROPackaging.Container] = 'Container',
    _1);
var WROServiceLevel;
(function (WROServiceLevel) {
    WROServiceLevel["Unknown"] = "ServiceLevelUnknown";
    WROServiceLevel["Standard"] = "Standard";
    WROServiceLevel["RushOneDay"] = "RushOneDay";
    WROServiceLevel["RushTwoDay"] = "RushTwoDay";
})(WROServiceLevel = exports.WROServiceLevel || (exports.WROServiceLevel = {}));
exports.WROServiceLevels = [WROServiceLevel.Standard, WROServiceLevel.RushTwoDay, WROServiceLevel.RushOneDay];
exports.HumanizeWROServiceLevel = (_2 = {},
    _2[WROServiceLevel.Unknown] = 'Unkown',
    _2[WROServiceLevel.Standard] = 'Standard - 3 days from receipt',
    _2[WROServiceLevel.RushTwoDay] = 'Rush 48 - 2 days from receipt',
    _2[WROServiceLevel.RushOneDay] = 'Rush 24 - 1 day from receipt',
    _2);
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["UNSPECIFIED"] = "STATUS_UNSPECIFIED";
    InvoiceStatus["OPEN"] = "STATUS_OPEN";
    InvoiceStatus["CLOSED"] = "STATUS_CLOSED";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var ShippingRegion;
(function (ShippingRegion) {
    ShippingRegion["Unspecified"] = "REGION_UNSPECIFIED";
    ShippingRegion["UnitedKingdom"] = "REGION_UNITED_KINGDOM";
    ShippingRegion["UnitedStates"] = "REGION_UNITED_STATES";
    ShippingRegion["Europe"] = "REGION_EUROPE";
    ShippingRegion["RestOfWorld"] = "REGION_REST_OF_WORLD";
})(ShippingRegion = exports.ShippingRegion || (exports.ShippingRegion = {}));
exports.ShippingRegions = [
    ShippingRegion.UnitedKingdom,
    ShippingRegion.UnitedStates,
    ShippingRegion.Europe,
    ShippingRegion.RestOfWorld,
];
exports.HumanizeShippingRegion = (_3 = {},
    _3[ShippingRegion.Unspecified] = 'Unspecified',
    _3[ShippingRegion.UnitedKingdom] = 'United Kingdom',
    _3[ShippingRegion.UnitedStates] = 'United States',
    _3[ShippingRegion.Europe] = 'Europe',
    _3[ShippingRegion.RestOfWorld] = 'Rest of World',
    _3);
// todo: migrate all inventory resources to namespace
var Inventory;
(function (Inventory) {
    var _a, _b, _c, _d;
    var ResourceType;
    (function (ResourceType) {
        ResourceType["Unspecified"] = "RESOURCE_TYPE_UNSPECIFIED";
        ResourceType["Product"] = "RESOURCE_TYPE_PRODUCT";
        ResourceType["Packaging"] = "RESOURCE_TYPE_PACKAGING";
    })(ResourceType = Inventory.ResourceType || (Inventory.ResourceType = {}));
    Inventory.ResourceTypes = [ResourceType.Packaging, ResourceType.Product];
    Inventory.HumanizeResourceType = (_a = {},
        _a[ResourceType.Unspecified] = 'Unspecified',
        _a[ResourceType.Packaging] = 'Packaging',
        _a[ResourceType.Product] = 'Product',
        _a);
    var PickingPreference;
    (function (PickingPreference) {
        PickingPreference["Unknown"] = "PICKING_PREFERENCE_UNSPECIFIED";
        PickingPreference["FIFO"] = "PICKING_PREFERENCE_FIFO";
        PickingPreference["FEFO"] = "PICKING_PREFERENCE_FEFO";
    })(PickingPreference || (PickingPreference = {}));
    Inventory.PickingPreferences = [PickingPreference.FIFO, PickingPreference.FEFO];
    Inventory.HumanizePickingPreference = (_b = {},
        _b[PickingPreference.Unknown] = 'Unknown',
        _b[PickingPreference.FEFO] = 'FEFO: First Expiring, First Out',
        _b[PickingPreference.FIFO] = 'FIFO: First In, First Out',
        _b);
    var AllocationPreference;
    (function (AllocationPreference) {
        AllocationPreference["Unknown"] = "INVENTORY_ALLOCATION_PREFERENCE_UNSPECIFIED";
        AllocationPreference["FirstInFirstOut"] = "FIRST_IN_FIRST_OUT";
        AllocationPreference["DeliverySLA"] = "DELIVERY_SLA";
        AllocationPreference["InventoryAvailability"] = "INVENTORY_AVAILABILITY";
    })(AllocationPreference || (AllocationPreference = {}));
    Inventory.AllocationPreferences = [
        AllocationPreference.FirstInFirstOut,
        AllocationPreference.DeliverySLA,
        AllocationPreference.InventoryAvailability,
    ];
    Inventory.HumanizeAllocationPreference = (_c = {},
        _c[AllocationPreference.Unknown] = 'Unknown',
        _c[AllocationPreference.FirstInFirstOut] = 'First In, First Out',
        _c[AllocationPreference.DeliverySLA] = 'Delivery SLA',
        _c[AllocationPreference.InventoryAvailability] = 'Inventory Availability',
        _c);
    var LocationSize;
    (function (LocationSize) {
        LocationSize["Unknown"] = "LOCATION_SIZE_UNKNOWN";
        LocationSize["Bin"] = "LOCATION_SIZE_BIN";
        LocationSize["Pallet"] = "LOCATION_SIZE_PALLET";
    })(LocationSize = Inventory.LocationSize || (Inventory.LocationSize = {}));
    Inventory.LocationSizes = [LocationSize.Bin, LocationSize.Pallet];
    Inventory.HumanizeLocationSize = (_d = {},
        _d[LocationSize.Unknown] = 'Unknown',
        _d[LocationSize.Bin] = 'Bin',
        _d[LocationSize.Pallet] = 'Pallet',
        _d);
    function SortLocations(a, b) {
        var _a, _b, _c, _d;
        if (((_a = a.site) === null || _a === void 0 ? void 0 : _a.name) !== ((_b = b.site) === null || _b === void 0 ? void 0 : _b.name))
            return (((_c = a.site) === null || _c === void 0 ? void 0 : _c.name) || '') > (((_d = b.site) === null || _d === void 0 ? void 0 : _d.name) || '') ? 1 : -1;
        if (a.position.zone !== b.position.zone)
            return SortNumericIfPossible(a.position.zone || '', b.position.zone || '');
        if (a.position.aisle !== b.position.aisle)
            return SortNumericIfPossible(a.position.aisle, b.position.aisle);
        if (a.position.bay !== b.position.bay)
            return SortNumericIfPossible(a.position.bay, b.position.bay);
        if (a.position.level !== b.position.level)
            return SortNumericIfPossible(a.position.level, b.position.level);
        if (a.position.bin !== b.position.bin)
            return SortNumericIfPossible(a.position.bin, b.position.bin);
        return 0;
    }
    Inventory.SortLocations = SortLocations;
})(Inventory = exports.Inventory || (exports.Inventory = {}));
var InventoryLocationAccessibility;
(function (InventoryLocationAccessibility) {
    InventoryLocationAccessibility["Unknown"] = "LOCATION_ACCESSIBILITY_UNSPECIFIED";
    InventoryLocationAccessibility["Easy"] = "LOCATION_ACCESSIBILITY_EASY";
    InventoryLocationAccessibility["Moderate"] = "LOCATION_ACCESSIBILITY_MODERATE";
    InventoryLocationAccessibility["Difficult"] = "LOCATION_ACCESSIBILITY_DIFFICULT";
})(InventoryLocationAccessibility = exports.InventoryLocationAccessibility || (exports.InventoryLocationAccessibility = {}));
exports.InventoryLocationAccessibilities = [
    InventoryLocationAccessibility.Easy,
    InventoryLocationAccessibility.Moderate,
    InventoryLocationAccessibility.Difficult,
];
exports.HumanizeInventoryLocationAccessibility = (_4 = {},
    _4[InventoryLocationAccessibility.Unknown] = 'Unknown',
    _4[InventoryLocationAccessibility.Easy] = 'Easy',
    _4[InventoryLocationAccessibility.Moderate] = 'Moderate',
    _4[InventoryLocationAccessibility.Difficult] = 'Difficult',
    _4);
var InventoryCategory;
(function (InventoryCategory) {
    InventoryCategory["Unknown"] = "CATEGORY_UNSPECIFIED";
    InventoryCategory["WROProcessed"] = "WRO_PROCESSED";
    InventoryCategory["ReturnProcessed"] = "RETURN_PROCESSED";
    InventoryCategory["OrderProcessed"] = "ORDER_PROCESSED";
    InventoryCategory["Transfer"] = "TRANSFER";
    InventoryCategory["Adjustment"] = "ADJUSTMENT";
})(InventoryCategory = exports.InventoryCategory || (exports.InventoryCategory = {}));
exports.InventoryCategories = [
    InventoryCategory.WROProcessed,
    InventoryCategory.ReturnProcessed,
    InventoryCategory.OrderProcessed,
    InventoryCategory.Transfer,
    InventoryCategory.Adjustment,
];
exports.HumanizeInventoryCategory = (_5 = {},
    _5[InventoryCategory.Unknown] = 'Unknown',
    _5[InventoryCategory.WROProcessed] = 'ASN Processed',
    _5[InventoryCategory.ReturnProcessed] = 'Return Processed',
    _5[InventoryCategory.OrderProcessed] = 'Order Processed',
    _5[InventoryCategory.Transfer] = 'Transfer',
    _5[InventoryCategory.Adjustment] = 'Adjustment',
    _5);
function InventoryLocationNameWithSite(l) {
    var _a;
    return ((_a = l.site) === null || _a === void 0 ? void 0 : _a.name) + " " + l.long_description;
}
exports.InventoryLocationNameWithSite = InventoryLocationNameWithSite;
var chars = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
];
// 1 => a, 2 => b, 2 => c, ...
function NumberToChar(n) {
    return chars[n - 1] || '?';
}
exports.NumberToChar = NumberToChar;
var InventoryCondition;
(function (InventoryCondition) {
    InventoryCondition["Sellable"] = "SELLABLE";
    InventoryCondition["Unsellable"] = "UNSELLABLE";
    InventoryCondition["All"] = "ALL";
})(InventoryCondition = exports.InventoryCondition || (exports.InventoryCondition = {}));
exports.InventoryConditions = [InventoryCondition.Sellable, InventoryCondition.Unsellable, InventoryCondition.All];
exports.HumanizeInventoryCondition = (_6 = {},
    _6[InventoryCondition.Sellable] = 'Sellable',
    _6[InventoryCondition.Unsellable] = 'Unsellable',
    _6[InventoryCondition.All] = 'All',
    _6);
var InventorySourceType;
(function (InventorySourceType) {
    InventorySourceType["Unknown"] = "SOURCE_TYPE_UNSPECIFIED";
    InventorySourceType["RestockOrder"] = "RESTOCK_ORDER";
    InventorySourceType["Return"] = "RETURN";
    InventorySourceType["WRO"] = "WRO";
    InventorySourceType["Migration"] = "MIGRATION";
})(InventorySourceType = exports.InventorySourceType || (exports.InventorySourceType = {}));
exports.InventorySourceTypes = [
    InventorySourceType.RestockOrder,
    InventorySourceType.Return,
    InventorySourceType.WRO,
    InventorySourceType.Migration,
];
exports.HumanizeInventorySourceType = (_7 = {},
    _7[InventorySourceType.Unknown] = 'Unknown',
    _7[InventorySourceType.RestockOrder] = 'Order Restocked',
    _7[InventorySourceType.Return] = 'Return',
    _7[InventorySourceType.WRO] = 'ASN',
    _7[InventorySourceType.Migration] = 'Migration',
    _7);
var PackagingFormat;
(function (PackagingFormat) {
    PackagingFormat["Unknown"] = "FORMAT_UNKNOWN";
    PackagingFormat["Letter"] = "FORMAT_LETTER";
    PackagingFormat["LargeLetter"] = "FORMAT_LARGE_LETTER";
    PackagingFormat["MailerBag"] = "FORMAT_MAILER_BAG";
    PackagingFormat["Parcel"] = "FORMAT_PARCEL";
})(PackagingFormat = exports.PackagingFormat || (exports.PackagingFormat = {}));
exports.PackagingFormats = [
    PackagingFormat.Letter,
    PackagingFormat.LargeLetter,
    PackagingFormat.MailerBag,
    PackagingFormat.Parcel,
];
exports.HumanizePackagingFormat = (_8 = {},
    _8[PackagingFormat.Unknown] = 'Unknown',
    _8[PackagingFormat.Letter] = 'Letter',
    _8[PackagingFormat.LargeLetter] = 'Large Letter',
    _8[PackagingFormat.MailerBag] = 'Mailer Bag',
    _8[PackagingFormat.Parcel] = 'Parcel',
    _8);
var ExportDuties;
(function (ExportDuties) {
    ExportDuties["Unknown"] = "ExportDutiesUnknown";
    ExportDuties["Unpaid"] = "ExportDutiesUnpaid";
    ExportDuties["Paid"] = "ExportDutiesPaid";
    ExportDuties["IOSS"] = "ExportDutiesIOSS";
})(ExportDuties = exports.ExportDuties || (exports.ExportDuties = {}));
exports.HumanizeExportDuties = (_9 = {},
    _9[ExportDuties.Unknown] = 'Unknown',
    _9[ExportDuties.Unpaid] = 'Unpaid (DDU)',
    _9[ExportDuties.Paid] = 'Paid (DDP)',
    _9[ExportDuties.IOSS] = 'Import One Stop Shop (IOSS)',
    _9);
var ExceptionReason;
(function (ExceptionReason) {
    ExceptionReason["Unknown"] = "ExceptionReasonUnknown";
    ExceptionReason["UnexpectedStatus"] = "UnexepctedStatus";
    ExceptionReason["Delayed"] = "Delayed";
})(ExceptionReason = exports.ExceptionReason || (exports.ExceptionReason = {}));
exports.ExceptionReasons = [ExceptionReason.UnexpectedStatus, ExceptionReason.Delayed];
exports.HumanizeExceptionReason = (_10 = {},
    _10[ExceptionReason.Unknown] = 'Unknown',
    _10[ExceptionReason.UnexpectedStatus] = 'Unexpected Status',
    _10[ExceptionReason.Delayed] = 'Delayed',
    _10);
var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["Unknown"] = "DeliveryStatusUnknown";
    DeliveryStatus["Pending"] = "Pending";
    DeliveryStatus["PickedUp"] = "PickedUp";
    DeliveryStatus["InTransit"] = "InTransit";
    DeliveryStatus["ArrivedAtCustoms"] = "ArrivedAtCustoms";
    DeliveryStatus["HeldAtCustoms"] = "HeldAtCustoms";
    DeliveryStatus["ClearedCustoms"] = "ClearedCustoms";
    DeliveryStatus["Attempted"] = "Attempted";
    DeliveryStatus["Scheduled"] = "Scheduled";
    DeliveryStatus["Completed"] = "Completed";
    DeliveryStatus["Failed"] = "Failed";
    DeliveryStatus["Returned"] = "Returned";
    DeliveryStatus["Damaged"] = "Damaged";
    DeliveryStatus["AwaitingCollection"] = "AwaitingCollection";
    DeliveryStatus["AwaitingInformation"] = "AwaitingInformation";
    DeliveryStatus["AwaitingPayment"] = "AwaitingPayment";
    DeliveryStatus["Unavailable"] = "Unavailable";
})(DeliveryStatus = exports.DeliveryStatus || (exports.DeliveryStatus = {}));
exports.DeliveryStatuses = [
    DeliveryStatus.Unknown,
    DeliveryStatus.Unavailable,
    DeliveryStatus.Unknown,
    DeliveryStatus.Pending,
    DeliveryStatus.PickedUp,
    DeliveryStatus.InTransit,
    DeliveryStatus.ArrivedAtCustoms,
    DeliveryStatus.HeldAtCustoms,
    DeliveryStatus.ClearedCustoms,
    DeliveryStatus.AwaitingCollection,
    DeliveryStatus.AwaitingInformation,
    DeliveryStatus.AwaitingPayment,
    DeliveryStatus.Failed,
    DeliveryStatus.Returned,
    DeliveryStatus.Damaged,
    DeliveryStatus.Attempted,
    DeliveryStatus.Scheduled,
    DeliveryStatus.Completed,
];
exports.HumanizeDeliveryStatus = (_11 = {},
    _11[DeliveryStatus.Unknown] = 'Loading',
    _11[DeliveryStatus.Unavailable] = 'Unavailable',
    _11[DeliveryStatus.Pending] = 'Pending',
    _11[DeliveryStatus.PickedUp] = 'Picked Up',
    _11[DeliveryStatus.InTransit] = 'In Transit',
    _11[DeliveryStatus.ArrivedAtCustoms] = 'Arrived At Customs',
    _11[DeliveryStatus.HeldAtCustoms] = 'Held At Customs',
    _11[DeliveryStatus.ClearedCustoms] = 'Cleared Customs',
    _11[DeliveryStatus.Attempted] = 'Attempted',
    _11[DeliveryStatus.Scheduled] = 'Scheduled',
    _11[DeliveryStatus.Completed] = 'Delivered',
    _11[DeliveryStatus.Failed] = 'Failed',
    _11[DeliveryStatus.Returned] = 'Returned',
    _11[DeliveryStatus.Damaged] = 'Damaged In Transit',
    _11[DeliveryStatus.AwaitingCollection] = 'Awaiting Collection',
    _11[DeliveryStatus.AwaitingInformation] = 'Awaiting Information',
    _11[DeliveryStatus.AwaitingPayment] = 'Awaiting Payment',
    _11);
var GiftingCampaignStatus;
(function (GiftingCampaignStatus) {
    GiftingCampaignStatus["Unknown"] = "CAMPAIGN_STATUS_UNSPECIFIED";
    GiftingCampaignStatus["Active"] = "ACTIVE";
    GiftingCampaignStatus["Closed"] = "CLOSED";
})(GiftingCampaignStatus = exports.GiftingCampaignStatus || (exports.GiftingCampaignStatus = {}));
exports.HumanizeGiftingCampaignStatus = (_12 = {},
    _12[GiftingCampaignStatus.Unknown] = 'Unknown',
    _12[GiftingCampaignStatus.Active] = 'Active',
    _12[GiftingCampaignStatus.Closed] = 'Closed',
    _12);
var GiftStatus;
(function (GiftStatus) {
    GiftStatus["Unknown"] = "GIFT_STATUS_UNSPECIFIED";
    GiftStatus["Pending"] = "PENDING";
    GiftStatus["Redeemed"] = "REDEEMED";
    GiftStatus["Cancelled"] = "CANCELLED";
})(GiftStatus = exports.GiftStatus || (exports.GiftStatus = {}));
exports.HumanizeGiftStatus = (_13 = {},
    _13[GiftStatus.Unknown] = 'Unknown',
    _13[GiftStatus.Pending] = 'Pending',
    _13[GiftStatus.Redeemed] = 'Redeemed',
    _13[GiftStatus.Cancelled] = 'Cancelled',
    _13);
var AutomationDataType;
(function (AutomationDataType) {
    AutomationDataType["Unknown"] = "DATA_TYPE_UNSPECIFIED";
    AutomationDataType["Object"] = "DATA_TYPE_OBJECT";
    AutomationDataType["String"] = "DATA_TYPE_STRING";
    AutomationDataType["Int32"] = "DATA_TYPE_INT32";
    AutomationDataType["Float"] = "DATA_TYPE_FLOAT";
    AutomationDataType["Bool"] = "DATA_TYPE_BOOL";
})(AutomationDataType = exports.AutomationDataType || (exports.AutomationDataType = {}));
var AutomationElementType;
(function (AutomationElementType) {
    AutomationElementType["Unknown"] = "ELEMENT_TYPE_UNSPECIFIED";
    AutomationElementType["Trigger"] = "ELEMENT_TYPE_TRIGGER";
    AutomationElementType["Check"] = "ELEMENT_TYPE_CHECK";
    AutomationElementType["Action"] = "ELEMENT_TYPE_ACTION";
})(AutomationElementType = exports.AutomationElementType || (exports.AutomationElementType = {}));
var AutomationCheckRequirement;
(function (AutomationCheckRequirement) {
    AutomationCheckRequirement["Unknown"] = "CHECK_REQUIREMENT_UNSPECIFIED";
    AutomationCheckRequirement["RequireAll"] = "CHECK_REQUIREMENT_REQUIRE_ALL";
    AutomationCheckRequirement["RequireAny"] = "CHECK_REQUIREMENT_REQUIRE_ANY";
})(AutomationCheckRequirement = exports.AutomationCheckRequirement || (exports.AutomationCheckRequirement = {}));
var AutomationConditionType;
(function (AutomationConditionType) {
    AutomationConditionType["Unknown"] = "CONDITION_TYPE_UNSPECIFIED";
    AutomationConditionType["EqualTo"] = "CONDITION_TYPE_EQUAL_TO";
    AutomationConditionType["NotEqualTo"] = "CONDITION_TYPE_NOT_EQUAL_TO";
    AutomationConditionType["LessThan"] = "CONDITION_TYPE_LESS_THAN";
    AutomationConditionType["LessThanOrEqualTo"] = "CONDITION_TYPE_LESS_THAN_OR_EQUAL_TO";
    AutomationConditionType["GreaterThan"] = "CONDITION_TYPE_GREATER_THAN";
    AutomationConditionType["GreaterThanOrEqualTo"] = "CONDITION_TYPE_GREATER_THAN_OR_EQUAL_TO";
    AutomationConditionType["Contains"] = "CONDITION_TYPE_CONTAINS";
    AutomationConditionType["NotContains"] = "CONDITION_TYPE_NOT_CONTAINS";
})(AutomationConditionType = exports.AutomationConditionType || (exports.AutomationConditionType = {}));
exports.HumanizeAutomationConditionType = (_14 = {},
    _14[AutomationConditionType.Unknown] = 'Unknown',
    _14[AutomationConditionType.EqualTo] = 'is equal to',
    _14[AutomationConditionType.NotEqualTo] = 'is not equal to',
    _14[AutomationConditionType.LessThan] = 'is less than',
    _14[AutomationConditionType.LessThanOrEqualTo] = 'is less than or equal to',
    _14[AutomationConditionType.GreaterThan] = 'is greater than',
    _14[AutomationConditionType.GreaterThanOrEqualTo] = 'is greater than or equal to',
    _14[AutomationConditionType.Contains] = 'does contain',
    _14[AutomationConditionType.NotContains] = 'does not contain',
    _14);
exports.AutomationConditionTypes = [
    AutomationConditionType.EqualTo,
    AutomationConditionType.NotEqualTo,
    AutomationConditionType.LessThan,
    AutomationConditionType.LessThanOrEqualTo,
    AutomationConditionType.GreaterThan,
    AutomationConditionType.GreaterThanOrEqualTo,
    AutomationConditionType.Contains,
    AutomationConditionType.NotContains,
];
exports.AutomationConditionTypesPerDataType = (_15 = {},
    _15[AutomationDataType.Unknown] = [],
    _15[AutomationDataType.Object] = [],
    _15[AutomationDataType.String] = [
        AutomationConditionType.EqualTo,
        AutomationConditionType.NotEqualTo,
        AutomationConditionType.Contains,
        AutomationConditionType.NotContains,
    ],
    _15[AutomationDataType.Int32] = [
        AutomationConditionType.EqualTo,
        AutomationConditionType.NotEqualTo,
        AutomationConditionType.LessThan,
        AutomationConditionType.LessThanOrEqualTo,
        AutomationConditionType.GreaterThan,
        AutomationConditionType.GreaterThanOrEqualTo,
    ],
    _15[AutomationDataType.Float] = [
        AutomationConditionType.EqualTo,
        AutomationConditionType.NotEqualTo,
        AutomationConditionType.LessThan,
        AutomationConditionType.LessThanOrEqualTo,
        AutomationConditionType.GreaterThan,
        AutomationConditionType.GreaterThanOrEqualTo,
    ],
    _15[AutomationDataType.Bool] = [AutomationConditionType.EqualTo, AutomationConditionType.NotEqualTo],
    _15);
var AutomationRunStatus;
(function (AutomationRunStatus) {
    AutomationRunStatus["Unknown"] = "RUN_STATUS_UNSPECIFIED";
    AutomationRunStatus["Processing"] = "RUN_STATUS_PROCESSING";
    AutomationRunStatus["Completed"] = "RUN_STATUS_COMPLETED";
    AutomationRunStatus["Failed"] = "RUN_STATUS_FAILED";
})(AutomationRunStatus = exports.AutomationRunStatus || (exports.AutomationRunStatus = {}));
exports.HumanizeAutomationRunStatus = (_16 = {},
    _16[AutomationRunStatus.Unknown] = 'Unknown',
    _16[AutomationRunStatus.Processing] = 'Processing',
    _16[AutomationRunStatus.Completed] = 'Completed',
    _16[AutomationRunStatus.Failed] = 'Failed',
    _16);
function AutomationValueDataType(v) {
    if (v.variable)
        return v.variable.type;
    if (v.string_value !== undefined)
        return AutomationDataType.String;
    if (v.int32_value !== undefined)
        return AutomationDataType.Int32;
    if (v.float_value !== undefined)
        return AutomationDataType.Float;
    if (v.bool_value !== undefined)
        return AutomationDataType.Bool;
    return AutomationDataType.Unknown;
}
exports.AutomationValueDataType = AutomationValueDataType;
function AutomationValueRawValue(v) {
    var _a;
    return ((_a = v.variable) === null || _a === void 0 ? void 0 : _a.key) || v.string_value || v.int32_value || v.float_value || v.bool_value;
}
exports.AutomationValueRawValue = AutomationValueRawValue;
function AutomationValueDisplayAs(v) {
    var _a;
    return v.display_as || ((_a = v.variable) === null || _a === void 0 ? void 0 : _a.name) || v.string_value || v.int32_value || v.float_value || v.bool_value;
}
exports.AutomationValueDisplayAs = AutomationValueDisplayAs;
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["Unknown"] = "STATUS_UNSPECIFIED";
    TaskStatus["Pending"] = "STATUS_PENDING";
    TaskStatus["InProgress"] = "STATUS_IN_PROGRESS";
    TaskStatus["Blocked"] = "STATUS_BLOCKED";
    TaskStatus["Completed"] = "STATUS_COMPLETED";
    TaskStatus["Cancelled"] = "STATUS_CANCELLED";
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
exports.TaskStatuses = [
    TaskStatus.Pending,
    TaskStatus.InProgress,
    TaskStatus.Blocked,
    TaskStatus.Completed,
    TaskStatus.Cancelled,
];
exports.HumanizeTaskStatus = (_17 = {},
    _17[TaskStatus.Unknown] = 'Unknown',
    _17[TaskStatus.Pending] = 'Pending',
    _17[TaskStatus.InProgress] = 'In Progress',
    _17[TaskStatus.Blocked] = 'Blocked',
    _17[TaskStatus.Completed] = 'Completed',
    _17[TaskStatus.Cancelled] = 'Cancelled',
    _17);
var TaskCategory;
(function (TaskCategory) {
    TaskCategory["Unknown"] = "CATEGORY_UNSPECIFIED";
    TaskCategory["Barcoding"] = "CATEGORY_BARCODING";
    TaskCategory["Kitting"] = "CATEGORY_KITTING";
    TaskCategory["InventoryCheck"] = "CATEGORY_INVENTORY_CHECK";
    TaskCategory["Returns"] = "CATEGORY_RETURNS";
})(TaskCategory = exports.TaskCategory || (exports.TaskCategory = {}));
exports.TaskCategories = [
    TaskCategory.Barcoding,
    TaskCategory.Kitting,
    TaskCategory.InventoryCheck,
    TaskCategory.Returns,
];
exports.HumanizeTaskCategory = (_18 = {},
    _18[TaskCategory.Unknown] = 'Unknown',
    _18[TaskCategory.Barcoding] = 'Barcoding',
    _18[TaskCategory.Kitting] = 'Kitting',
    _18[TaskCategory.InventoryCheck] = 'Stock Check',
    _18[TaskCategory.Returns] = 'Returns',
    _18);
function SortNumericIfPossible(a, b) {
    if (isNumeric(a) && isNumeric(b))
        return parseFloat(a) > parseFloat(b) ? 1 : -1;
    return a > b ? 1 : -1;
}
exports.SortNumericIfPossible = SortNumericIfPossible;
function isNumeric(str) {
    return !isNaN(str) && !isNaN(parseFloat(str));
}
function Pluralize(str, count) {
    if (count === 1)
        return str;
    if (str.endsWith('s'))
        return str;
    return str + 's';
}
exports.Pluralize = Pluralize;
function FormatCurrency(val) {
    if (!val)
        return '£0.00';
    return '£' + (val / 100).toFixed(2);
}
exports.FormatCurrency = FormatCurrency;
function FormatCurrencyAbsolute(val) {
    if (!val)
        return FormatCurrency(val);
    if (val < 0)
        return FormatCurrency(val * -1);
    return FormatCurrency(val);
}
exports.FormatCurrencyAbsolute = FormatCurrencyAbsolute;
